var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVacuumFormer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.68 923.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 407.075,
    y1: 310.13,
    x2: 407.075,
    y2: 4.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7b299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d8c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "506.93 0 506.93 923.77 296.71 835.31 296.71 37.01 506.93 0",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.18,
    width: 11.499,
    height: 923.77,
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.895,107.752h0c-1.386,.199-2.507-.44-2.507-1.426v-36.664c0-.986,1.121-1.982,2.507-2.224h0c1.389-.243,2.517,.362,2.517,1.352v36.808c0,.99-1.128,1.955-2.517,2.154Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,92.239v-7.029c0-1.957,2.219-3.909,4.967-4.362l4.263-.703c2.778-.458,5.039,.774,5.039,2.753v7.107c0,1.979-2.261,3.931-5.039,4.358l-4.263,.655c-2.748,.422-4.967-.823-4.967-2.78Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.562,104.643h0c-1.433,.206-2.592-.441-2.592-1.444v-37.282c0-1.003,1.159-2.019,2.592-2.27h0c1.436-.251,2.603,.361,2.603,1.368v37.431c0,1.007-1.167,1.991-2.603,2.197Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.226,88.887v-7.147c0-1.99,2.294-3.981,5.135-4.45l4.408-.726c2.873-.473,5.212,.773,5.212,2.786v7.228c0,2.013-2.338,4.004-5.211,4.446l-4.408,.678c-2.841,.437-5.136-.824-5.136-2.814Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.974,101.427h0c-1.483,.213-2.682-.442-2.682-1.462V62.042c0-1.02,1.2-2.057,2.682-2.316h0c1.486-.26,2.693,.359,2.693,1.383v38.076c0,1.024-1.207,2.028-2.693,2.241Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.384,85.419v-7.269c0-2.024,2.373-4.056,5.313-4.541l4.561-.752c2.973-.49,5.393,.771,5.393,2.819v7.353c0,2.048-2.42,4.079-5.393,4.536l-4.561,.701c-2.94,.452-5.313-.824-5.313-2.848Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.17,98.098h0c-1.535,.22-2.777-.443-2.777-1.481V58.033c0-1.038,1.242-2.097,2.777-2.365h0c1.539-.269,2.788,.357,2.788,1.399v38.744c0,1.042-1.25,2.067-2.788,2.287Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.313,81.831v-7.395c0-2.059,2.457-4.134,5.5-4.635l4.722-.778c3.078-.507,5.584,.769,5.584,2.853v7.483c0,2.084-2.506,4.158-5.584,4.631l-4.722,.726c-3.043,.468-5.5-.824-5.5-2.883Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.193,94.65h0c-1.59,.228-2.877-.444-2.877-1.5V53.88c0-1.056,1.286-2.138,2.877-2.416h0c1.594-.279,2.889,.355,2.889,1.415v39.435c0,1.061-1.295,2.107-2.889,2.335Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054,78.116v-7.526c0-2.096,2.544-4.214,5.697-4.734l4.892-.806c3.189-.526,5.786,.766,5.786,2.887v7.617c0,2.121-2.596,4.239-5.785,4.73l-4.892,.752c-3.152,.485-5.697-.823-5.697-2.919Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.087,91.078h0c-1.648,.237-2.982-.444-2.982-1.519V49.578c0-1.076,1.333-2.181,2.982-2.469h0c1.652-.289,2.994,.352,2.994,1.432v40.152c0,1.08-1.342,2.148-2.994,2.385Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.651,74.268v-7.662c0-2.134,2.637-4.298,5.904-4.836l5.071-.836c3.306-.545,5.998,.762,5.998,2.922v7.756c0,2.16-2.692,4.324-5.998,4.832l-5.071,.779c-3.267,.502-5.905-.822-5.905-2.956Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,87.373h0c-1.71,.245-3.093-.444-3.093-1.539V45.116c0-1.095,1.383-2.225,3.093-2.524h0c1.714-.3,3.106,.348,3.106,1.448v40.895c0,1.1-1.392,2.192-3.106,2.438Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.151,70.277v-7.803c0-2.173,2.735-4.385,6.123-4.943l5.26-.867c3.43-.565,6.223,.758,6.223,2.958v7.9c0,2.2-2.793,4.412-6.222,4.94l-5.26,.809c-3.389,.521-6.124-.82-6.124-2.993Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.685,83.529h0c-1.775,.255-3.21-.444-3.21-1.56V40.488c0-1.116,1.435-2.272,3.21-2.582h0c1.779-.311,3.224,.344,3.224,1.465v41.666c0,1.121-1.445,2.237-3.224,2.492Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.604,66.138v-7.949c0-2.213,2.838-4.475,6.355-5.055l5.46-.9c3.561-.587,6.46,.753,6.46,2.994v8.049c0,2.241-2.899,4.504-6.46,5.051l-5.46,.839c-3.517,.541-6.355-.817-6.355-3.031Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.895,168.523h0c-1.386,.133-2.507-.559-2.507-1.545v-36.664c0-.986,1.121-1.929,2.507-2.106h0c1.389-.177,2.517,.482,2.517,1.472v36.808c0,.99-1.128,1.901-2.517,2.035Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,152.674v-7.029c0-1.957,2.219-3.804,4.967-4.127l4.263-.5c2.778-.326,5.039,1.013,5.039,2.992v7.107c0,1.979-2.261,3.824-5.039,4.119l-4.263,.453c-2.748,.292-4.967-1.059-4.967-3.016Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.562,166.441h0c-1.433,.138-2.592-.564-2.592-1.567v-37.282c0-1.003,1.159-1.964,2.592-2.147h0c1.436-.183,2.603,.484,2.603,1.491v37.431c0,1.007-1.167,1.935-2.603,2.073Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.226,150.337v-7.147c0-1.99,2.294-3.873,5.135-4.206l4.408-.517c2.873-.337,5.212,1.02,5.212,3.033v7.228c0,2.013-2.338,3.893-5.211,4.198l-4.408,.469c-2.841,.302-5.136-1.067-5.136-3.058Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.974,164.288h0c-1.483,.142-2.682-.569-2.682-1.589v-37.922c0-1.02,1.2-2,2.682-2.189h0c1.486-.19,2.693,.487,2.693,1.511v38.076c0,1.024-1.207,1.971-2.693,2.113Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.384,147.921v-7.269c0-2.024,2.373-3.944,5.313-4.289l4.561-.535c2.973-.349,5.393,1.027,5.393,3.075v7.353c0,2.048-2.42,3.965-5.393,4.281l-4.561,.485c-2.94,.312-5.313-1.076-5.313-3.1Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.17,162.059h0c-1.535,.148-2.777-.575-2.777-1.613v-38.584c0-1.038,1.242-2.038,2.777-2.234h0c1.539-.196,2.788,.489,2.788,1.532v38.744c0,1.042-1.25,2.007-2.788,2.155Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.313,145.42v-7.395c0-2.059,2.457-4.017,5.5-4.374l4.722-.554c3.078-.361,5.584,1.034,5.584,3.117v7.483c0,2.084-2.506,4.039-5.584,4.366l-4.722,.502c-3.043,.323-5.5-1.085-5.5-3.144Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.193,159.75h0c-1.59,.153-2.877-.58-2.877-1.636v-39.27c0-1.056,1.286-2.077,2.877-2.28h0c1.594-.203,2.889,.492,2.889,1.552v39.435c0,1.061-1.295,2.045-2.889,2.198Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054,142.831v-7.526c0-2.096,2.544-4.093,5.697-4.463l4.892-.574c3.189-.374,5.786,1.04,5.786,3.161v7.617c0,2.121-2.596,4.116-5.785,4.455l-4.892,.52c-3.152,.335-5.697-1.093-5.697-3.189Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.087,157.358h0c-1.648,.158-2.982-.585-2.982-1.661v-39.981c0-1.076,1.333-2.117,2.982-2.328h0c1.652-.211,2.994,.494,2.994,1.574v40.152c0,1.08-1.342,2.085-2.994,2.243Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.651,140.148v-7.662c0-2.134,2.637-4.173,5.904-4.556l5.071-.595c3.306-.388,5.998,1.047,5.998,3.206v7.756c0,2.16-2.692,4.197-5.998,4.548l-5.071,.539c-3.267,.347-5.905-1.102-5.905-3.236Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,154.878h0c-1.71,.164-3.093-.591-3.093-1.686v-40.717c0-1.095,1.383-2.16,3.093-2.378h0c1.714-.219,3.106,.496,3.106,1.596v40.895c0,1.1-1.392,2.126-3.106,2.29Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.151,137.367v-7.803c0-2.173,2.735-4.255,6.123-4.653l5.26-.617c3.43-.403,6.223,1.053,6.223,3.253v7.9c0,2.2-2.793,4.28-6.222,4.645l-5.26,.559c-3.389,.36-6.124-1.11-6.124-3.283Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.685,152.304h0c-1.775,.171-3.21-.596-3.21-1.712v-41.482c0-1.116,1.435-2.204,3.21-2.43h0c1.779-.227,3.224,.497,3.224,1.618v41.666c0,1.121-1.445,2.168-3.224,2.339Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.604,134.482v-7.949c0-2.213,2.838-4.341,6.355-4.754l5.46-.641c3.561-.418,6.46,1.059,6.46,3.3v8.049c0,2.241-2.899,4.367-6.46,4.745l-5.46,.58c-3.517,.374-6.355-1.119-6.355-3.332Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.895,229.294h0c-1.386,.067-2.507-.678-2.507-1.664v-36.664c0-.986,1.121-1.876,2.507-1.987h0c1.389-.111,2.517,.601,2.517,1.591v36.808c0,.99-1.128,1.848-2.517,1.915Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,213.108v-7.029c0-1.957,2.219-3.699,4.967-3.891l4.263-.298c2.778-.194,5.039,1.252,5.039,3.231v7.107c0,1.979-2.261,3.717-5.039,3.88l-4.263,.251c-2.748,.162-4.967-1.294-4.967-3.252Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.562,228.239h0c-1.433,.07-2.592-.687-2.592-1.69v-37.282c0-1.003,1.159-1.909,2.592-2.024h0c1.436-.115,2.603,.608,2.603,1.615v37.431c0,1.007-1.167,1.88-2.603,1.95Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.226,211.788v-7.147c0-1.99,2.294-3.764,5.135-3.963l4.408-.308c2.873-.201,5.212,1.267,5.212,3.28v7.228c0,2.013-2.338,3.782-5.211,3.951l-4.408,.26c-2.841,.167-5.136-1.311-5.136-3.301Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.974,227.149h0c-1.483,.072-2.682-.696-2.682-1.717v-37.922c0-1.02,1.2-1.943,2.682-2.062h0c1.486-.119,2.693,.615,2.693,1.639v38.076c0,1.024-1.207,1.913-2.693,1.986Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.384,210.422v-7.269c0-2.024,2.373-3.831,5.313-4.037l4.561-.319c2.973-.208,5.393,1.283,5.393,3.33v7.353c0,2.048-2.42,3.85-5.393,4.025l-4.561,.269c-2.94,.173-5.313-1.328-5.313-3.352Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.17,226.02h0c-1.535,.075-2.777-.706-2.777-1.744v-38.584c0-1.038,1.242-1.979,2.777-2.102h0c1.539-.123,2.788,.621,2.788,1.664v38.744c0,1.042-1.25,1.948-2.788,2.023Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.313,209.008v-7.395c0-2.059,2.457-3.901,5.5-4.114l4.722-.33c3.078-.215,5.584,1.299,5.584,3.382v7.483c0,2.084-2.506,3.92-5.584,4.102l-4.722,.278c-3.043,.179-5.5-1.346-5.5-3.405Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.193,224.85h0c-1.59,.077-2.877-.716-2.877-1.773v-39.27c0-1.056,1.286-2.016,2.877-2.143h0c1.594-.128,2.889,.629,2.889,1.689v39.435c0,1.061-1.295,1.984-2.889,2.061Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054,207.545v-7.526c0-2.096,2.544-3.973,5.697-4.193l4.892-.342c3.189-.223,5.786,1.315,5.786,3.436v7.617c0,2.121-2.596,3.993-5.785,4.181l-4.892,.288c-3.152,.186-5.697-1.364-5.697-3.46Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.087,223.639h0c-1.648,.08-2.982-.727-2.982-1.802v-39.981c0-1.076,1.333-2.054,2.982-2.186h0c1.652-.132,2.994,.636,2.994,1.716v40.152c0,1.08-1.342,2.021-2.994,2.101Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.651,206.029v-7.662c0-2.134,2.637-4.048,5.904-4.276l5.071-.355c3.306-.231,5.998,1.331,5.998,3.491v7.756c0,2.16-2.692,4.069-5.998,4.264l-5.071,.299c-3.267,.192-5.905-1.382-5.905-3.516Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,222.382h0c-1.71,.083-3.093-.737-3.093-1.833v-40.717c0-1.095,1.383-2.094,3.093-2.231h0c1.714-.137,3.106,.643,3.106,1.743v40.895c0,1.1-1.392,2.06-3.106,2.143Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.151,204.457v-7.803c0-2.173,2.735-4.125,6.123-4.362l5.26-.368c3.43-.24,6.223,1.348,6.223,3.548v7.9c0,2.2-2.793,4.147-6.222,4.349l-5.26,.31c-3.389,.2-6.124-1.401-6.124-3.574Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.685,221.079h0c-1.775,.086-3.21-.748-3.21-1.864v-41.482c0-1.116,1.435-2.136,3.21-2.278h0c1.779-.143,3.224,.65,3.224,1.771v41.666c0,1.121-1.445,2.1-3.224,2.186Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.604,202.826v-7.949c0-2.213,2.838-4.206,6.355-4.452l5.46-.382c3.561-.249,6.46,1.365,6.46,3.607v8.049c0,2.241-2.899,4.229-6.46,4.439l-5.46,.321c-3.517,.207-6.355-1.42-6.355-3.634Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.895,290.065h0c-1.386,.002-2.507-.796-2.507-1.783v-36.664c0-.986,1.121-1.822,2.507-1.868h0c1.389-.045,2.517,.72,2.517,1.711v36.808c0,.99-1.128,1.794-2.517,1.796Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,273.543v-7.029c0-1.957,2.219-3.594,4.967-3.656l4.263-.096c2.778-.063,5.039,1.491,5.039,3.47v7.107c0,1.979-2.261,3.609-5.039,3.641l-4.263,.049c-2.748,.032-4.967-1.53-4.967-3.487Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.562,290.038h0c-1.433,.002-2.592-.81-2.592-1.813v-37.282c0-1.003,1.159-1.854,2.592-1.901h0c1.436-.047,2.603,.731,2.603,1.738v37.431c0,1.007-1.167,1.825-2.603,1.826Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.226,273.238v-7.147c0-1.99,2.294-3.655,5.135-3.719l4.408-.099c2.873-.065,5.212,1.514,5.212,3.527v7.228c0,2.013-2.338,3.671-5.211,3.704l-4.408,.051c-2.841,.033-5.136-1.555-5.136-3.545Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.974,290.01h0c-1.483,.002-2.682-.824-2.682-1.844v-37.922c0-1.02,1.2-1.886,2.682-1.935h0c1.486-.049,2.693,.742,2.693,1.767v38.076c0,1.024-1.207,1.856-2.693,1.858Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.384,272.923v-7.269c0-2.024,2.373-3.719,5.313-3.785l4.561-.103c2.973-.067,5.393,1.538,5.393,3.586v7.353c0,2.048-2.42,3.735-5.393,3.769l-4.561,.052c-2.94,.034-5.313-1.58-5.313-3.604Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.17,289.981h0c-1.535,.002-2.777-.838-2.777-1.876v-38.584c0-1.038,1.242-1.92,2.777-1.97h0c1.539-.05,2.788,.754,2.788,1.796v38.744c0,1.042-1.25,1.889-2.788,1.891Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.313,272.597v-7.395c0-2.059,2.457-3.784,5.5-3.853l4.722-.106c3.078-.069,5.584,1.563,5.584,3.647v7.483c0,2.084-2.506,3.801-5.584,3.837l-4.722,.054c-3.043,.035-5.5-1.606-5.5-3.666Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.193,289.95h0c-1.59,.002-2.877-.853-2.877-1.909v-39.27c0-1.056,1.286-1.955,2.877-2.007h0c1.594-.052,2.889,.765,2.889,1.826v39.435c0,1.061-1.295,1.922-2.889,1.924Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054,272.259v-7.526c0-2.096,2.544-3.852,5.697-3.923l4.892-.11c3.189-.072,5.786,1.589,5.786,3.71v7.617c0,2.121-2.596,3.87-5.785,3.907l-4.892,.056c-3.152,.036-5.697-1.634-5.697-3.73Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.087,289.919h0c-1.648,.002-2.982-.868-2.982-1.944v-39.981c0-1.076,1.333-1.991,2.982-2.045h0c1.652-.054,2.994,.778,2.994,1.858v40.152c0,1.08-1.342,1.957-2.994,1.959Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.651,271.909v-7.662c0-2.134,2.637-3.923,5.904-3.996l5.071-.114c3.306-.075,5.998,1.616,5.998,3.775v7.756c0,2.16-2.692,3.941-5.998,3.979l-5.071,.058c-3.267,.037-5.905-1.662-5.905-3.796Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,289.887h0c-1.71,.002-3.093-.884-3.093-1.979v-40.717c0-1.095,1.383-2.029,3.093-2.084h0c1.714-.056,3.106,.79,3.106,1.89v40.895c0,1.1-1.392,1.994-3.106,1.996Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.151,271.546v-7.803c0-2.173,2.735-3.996,6.123-4.072l5.26-.119c3.43-.077,6.223,1.643,6.223,3.843v7.9c0,2.2-2.793,4.015-6.222,4.054l-5.26,.06c-3.389,.039-6.124-1.691-6.124-3.864Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.684,289.853h0c-1.775,.002-3.21-.901-3.21-2.016v-41.482c0-1.116,1.435-2.067,3.21-2.126h0c1.779-.058,3.224,.803,3.224,1.924v41.666c0,1.121-1.445,2.031-3.224,2.034Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.604,271.17v-7.949c0-2.213,2.838-4.072,6.355-4.151l5.46-.123c3.561-.08,6.46,1.672,6.46,3.913v8.049c0,2.241-2.899,4.092-6.46,4.133l-5.46,.063c-3.517,.04-6.355-1.722-6.355-3.935Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.895,350.836h0c-1.386-.064-2.507-.915-2.507-1.902v-36.664c0-.986,1.121-1.769,2.507-1.749h0c1.389,.02,2.517,.84,2.517,1.83v36.808c0,.99-1.128,1.741-2.517,1.677Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,333.977v-7.029c0-1.957,2.219-3.489,4.967-3.42l4.263,.106c2.778,.069,5.039,1.73,5.039,3.709v7.107c0,1.979-2.261,3.502-5.039,3.402l-4.263-.153c-2.748-.099-4.967-1.765-4.967-3.723Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.562,351.836h0c-1.433-.066-2.592-.933-2.592-1.936v-37.282c0-1.003,1.159-1.799,2.592-1.778h0c1.436,.021,2.603,.855,2.603,1.861v37.431c0,1.007-1.167,1.769-2.603,1.703Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.226,334.688v-7.147c0-1.99,2.294-3.546,5.135-3.476l4.408,.11c2.873,.071,5.212,1.761,5.212,3.774v7.228c0,2.013-2.338,3.56-5.211,3.457l-4.408-.158c-2.841-.102-5.136-1.798-5.136-3.788Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.974,352.871h0c-1.483-.068-2.682-.951-2.682-1.971v-37.922c0-1.02,1.2-1.829,2.682-1.808h0c1.486,.022,2.693,.87,2.693,1.894v38.076c0,1.024-1.207,1.799-2.693,1.73Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.384,335.424v-7.269c0-2.024,2.373-3.606,5.313-3.533l4.561,.113c2.973,.074,5.393,1.794,5.393,3.842v7.353c0,2.048-2.42,3.62-5.393,3.514l-4.561-.164c-2.94-.106-5.313-1.832-5.313-3.856Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.17,353.941h0c-1.535-.071-2.777-.97-2.777-2.008v-38.584c0-1.038,1.242-1.861,2.777-1.839h0c1.539,.023,2.788,.886,2.788,1.928v38.744c0,1.042-1.25,1.829-2.788,1.758Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.313,336.185v-7.395c0-2.059,2.457-3.668,5.5-3.592l4.722,.117c3.078,.077,5.584,1.828,5.584,3.912v7.483c0,2.084-2.506,3.683-5.584,3.572l-4.722-.17c-3.043-.109-5.5-1.867-5.5-3.927Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.193,355.05h0c-1.59-.073-2.877-.989-2.877-2.046v-39.27c0-1.056,1.286-1.894,2.877-1.87h0c1.594,.023,2.889,.902,2.889,1.963v39.435c0,1.061-1.295,1.861-2.889,1.787Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054,336.973v-7.526c0-2.096,2.544-3.731,5.697-3.653l4.892,.122c3.189,.079,5.786,1.863,5.786,3.984v7.617c0,2.121-2.596,3.747-5.785,3.632l-4.892-.176c-3.152-.113-5.697-1.904-5.697-4Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.087,356.2h0c-1.648-.076-2.982-1.01-2.982-2.085v-39.981c0-1.076,1.333-1.928,2.982-1.904h0c1.652,.024,2.994,.92,2.994,2v40.152c0,1.08-1.342,1.894-2.994,1.817Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.651,337.79v-7.662c0-2.134,2.637-3.798,5.904-3.716l5.071,.126c3.306,.082,5.998,1.9,5.998,4.06v7.756c0,2.16-2.692,3.814-5.998,3.695l-5.071-.182c-3.267-.117-5.905-1.942-5.905-4.076Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,357.391h0c-1.71-.079-3.093-1.031-3.093-2.126v-40.717c0-1.095,1.383-1.963,3.093-1.938h0c1.714,.025,3.106,.938,3.106,2.038v40.895c0,1.1-1.392,1.928-3.106,1.849Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.151,338.636v-7.803c0-2.173,2.735-3.866,6.123-3.782l5.26,.131c3.43,.085,6.223,1.938,6.223,4.138v7.9c0,2.2-2.793,3.883-6.222,3.759l-5.26-.189c-3.389-.122-6.124-1.982-6.124-4.154Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.684,358.628h0c-1.775-.082-3.21-1.053-3.21-2.169v-41.482c0-1.116,1.435-1.999,3.21-1.973h0c1.779,.026,3.224,.956,3.224,2.077v41.666c0,1.121-1.445,1.963-3.224,1.881Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.604,339.514v-7.949c0-2.213,2.838-3.937,6.355-3.85l5.46,.136c3.561,.089,6.46,1.978,6.46,4.219v8.049c0,2.241-2.899,3.954-6.46,3.826l-5.46-.196c-3.517-.126-6.355-2.023-6.355-4.236Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.895,411.606h0c-1.386-.13-2.507-1.034-2.507-2.02v-36.664c0-.986,1.121-1.716,2.507-1.63h0c1.389,.086,2.517,.959,2.517,1.949v36.808c0,.99-1.128,1.687-2.517,1.557Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,394.411v-7.029c0-1.957,2.219-3.383,4.967-3.185l4.263,.308c2.778,.201,5.039,1.969,5.039,3.948v7.107c0,1.979-2.261,3.395-5.039,3.163l-4.263-.355c-2.748-.229-4.967-2.001-4.967-3.958Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.562,413.634h0c-1.433-.134-2.592-1.056-2.592-2.059v-37.282c0-1.003,1.159-1.744,2.592-1.655h0c1.436,.089,2.603,.978,2.603,1.985v37.431c0,1.007-1.167,1.714-2.603,1.58Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.226,396.139v-7.147c0-1.99,2.294-3.438,5.135-3.232l4.408,.319c2.873,.208,5.212,2.009,5.212,4.021v7.228c0,2.013-2.338,3.449-5.211,3.21l-4.408-.368c-2.841-.237-5.136-2.042-5.136-4.032Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.974,415.732h0c-1.483-.139-2.682-1.078-2.682-2.098v-37.922c0-1.02,1.2-1.773,2.682-1.68h0c1.486,.092,2.693,.998,2.693,2.022v38.076c0,1.024-1.207,1.742-2.693,1.603Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.384,397.925v-7.269c0-2.024,2.373-3.493,5.313-3.281l4.561,.33c2.973,.215,5.393,2.05,5.393,4.098v7.353c0,2.048-2.42,3.506-5.393,3.258l-4.561-.38c-2.94-.245-5.313-2.084-5.313-4.108Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.17,417.902h0c-1.535-.144-2.777-1.101-2.777-2.139v-38.584c0-1.038,1.242-1.802,2.777-1.707h0c1.539,.096,2.788,1.018,2.788,2.06v38.744c0,1.042-1.25,1.77-2.788,1.626Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.313,399.773v-7.395c0-2.059,2.457-3.551,5.5-3.331l4.722,.341c3.078,.223,5.584,2.093,5.584,4.177v7.483c0,2.084-2.506,3.564-5.584,3.307l-4.722-.394c-3.043-.254-5.5-2.128-5.5-4.188Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.193,420.151h0c-1.59-.149-2.877-1.126-2.877-2.182v-39.27c0-1.056,1.286-1.833,2.877-1.734h0c1.594,.099,2.889,1.039,2.889,2.1v39.435c0,1.061-1.295,1.8-2.889,1.65Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054,401.687v-7.526c0-2.096,2.544-3.611,5.697-3.383l4.892,.354c3.189,.231,5.786,2.138,5.786,4.259v7.617c0,2.121-2.596,3.624-5.785,3.358l-4.892-.408c-3.152-.263-5.697-2.174-5.697-4.27Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.087,422.48h0c-1.648-.154-2.982-1.151-2.982-2.226v-39.981c0-1.076,1.333-1.865,2.982-1.762h0c1.652,.103,2.994,1.062,2.994,2.142v40.152c0,1.08-1.342,1.83-2.994,1.675Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.651,403.67v-7.662c0-2.134,2.637-3.673,5.904-3.436l5.071,.367c3.306,.239,5.998,2.185,5.998,4.344v7.756c0,2.16-2.692,3.686-5.998,3.41l-5.071-.423c-3.267-.272-5.905-2.222-5.905-4.356Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.9,424.896h0c-1.71-.16-3.093-1.177-3.093-2.273v-40.717c0-1.095,1.383-1.897,3.093-1.791h0c1.714,.106,3.106,1.085,3.106,2.185v40.895c0,1.1-1.392,1.862-3.106,1.701Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.151,405.726v-7.803c0-2.173,2.735-3.736,6.123-3.491l5.26,.38c3.43,.248,6.223,2.233,6.223,4.433v7.9c0,2.2-2.793,3.75-6.222,3.464l-5.26-.439c-3.389-.283-6.124-2.272-6.124-4.445Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.684,427.403h0c-1.775-.166-3.21-1.205-3.21-2.321v-41.482c0-1.116,1.435-1.931,3.21-1.821h0c1.779,.111,3.224,1.109,3.224,2.23v41.666c0,1.121-1.445,1.894-3.224,1.728Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.604,407.858v-7.949c0-2.213,2.838-3.802,6.355-3.548l5.46,.395c3.561,.257,6.46,2.284,6.46,4.526v8.049c0,2.241-2.899,3.817-6.46,3.52l-5.46-.455c-3.517-.293-6.355-2.324-6.355-4.538Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.493,487.81h0c-1.454-.215-2.632-1.168-2.632-2.128l-.004-35.667c0-.959,1.177-1.583,2.631-1.393h0c1.456,.19,2.637,1.123,2.637,2.085l.006,35.752c0,.962-1.182,1.567-2.638,1.351Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.033,470.597v-6.847c0-1.906,2.335-3.134,5.223-2.741l4.471,.609c2.907,.396,5.27,2.274,5.271,4.193l.002,6.894c0,1.92-2.362,3.14-5.27,2.726l-4.472-.637c-2.889-.411-5.225-2.29-5.225-4.197Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.075,491.156h0c-1.484-.22-2.686-1.184-2.687-2.154l-.014-36.032c0-.969,1.201-1.598,2.684-1.404h0c1.486,.194,2.692,1.138,2.692,2.11l.016,36.119c0,.972-1.206,1.581-2.692,1.361Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.457,473.755l-.002-6.917c0-1.926,2.382-3.163,5.33-2.761l4.563,.621c2.967,.404,5.379,2.304,5.38,4.244l.004,6.965c0,1.94-2.41,3.169-5.377,2.746l-4.563-.65c-2.948-.42-5.332-2.321-5.333-4.247Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.122,494.571h0c-1.515-.224-2.742-1.2-2.743-2.18l-.024-36.405c0-.979,1.225-1.612,2.739-1.415h0c1.516,.198,2.748,1.154,2.748,2.135l.026,36.494c0,.982-1.23,1.596-2.747,1.371Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.342,476.978l-.004-6.988c-.001-1.946,2.431-3.192,5.439-2.782l4.657,.634c3.029,.412,5.492,2.336,5.493,4.295l.006,7.037c.002,1.96-2.459,3.198-5.488,2.767l-4.658-.663c-3.009-.428-5.443-2.353-5.444-4.299Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.651,498.056h0c-1.547-.229-2.8-1.217-2.801-2.207l-.035-36.785c0-.989,1.25-1.628,2.796-1.426h0c1.548,.202,2.806,1.17,2.807,2.161l.037,36.876c0,.992-1.255,1.611-2.804,1.381Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.703,480.268l-.006-7.061c-.002-1.966,2.48-3.222,5.552-2.804l4.755,.647c3.093,.421,5.607,2.368,5.61,4.348l.008,7.111c.002,1.98-2.51,3.228-5.603,2.788l-4.756-.677c-3.072-.437-5.558-2.385-5.559-4.352Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.675,501.616h0c-1.58-.234-2.86-1.235-2.861-2.235l-.046-37.174c-.001-1,1.276-1.643,2.855-1.437h0c1.581,.206,2.865,1.186,2.867,2.188l.048,37.267c.001,1.003-1.282,1.626-2.863,1.391Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.555,483.628l-.008-7.136c-.002-1.987,2.532-3.252,5.668-2.825l4.856,.661c3.158,.43,5.727,2.402,5.73,4.403l.01,7.187c.003,2.001-2.562,3.258-5.721,2.809l-4.857-.692c-3.137-.447-5.675-2.419-5.678-4.406Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.212,505.251h0c-1.613-.239-2.921-1.252-2.923-2.263l-.057-37.571c-.002-1.01,1.303-1.659,2.916-1.449h0c1.615,.211,2.927,1.203,2.929,2.215l.06,37.666c.002,1.014-1.309,1.641-2.924,1.402Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.913,487.058l-.011-7.212c-.003-2.008,2.585-3.283,5.788-2.847l4.96,.675c3.226,.439,5.85,2.436,5.854,4.458l.012,7.264c.003,2.023-2.616,3.289-5.842,2.83l-4.961-.706c-3.204-.456-5.797-2.453-5.8-4.462Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.277,508.964h0c-1.648-.244-2.985-1.271-2.986-2.293l-.069-37.977c-.002-1.021,1.331-1.675,2.978-1.46h0c1.65,.215,2.991,1.22,2.993,2.243l.072,38.074c.002,1.025-1.336,1.657-2.987,1.412Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.794,490.562l-.013-7.29c-.004-2.03,2.64-3.315,5.912-2.869l5.067,.69c3.296,.449,5.978,2.471,5.982,4.515l.014,7.342c.004,2.045-2.672,3.321-5.968,2.852l-5.068-.722c-3.273-.466-5.923-2.489-5.926-4.519Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.888,512.759h0c-1.684-.25-3.05-1.289-3.052-2.322l-.082-38.391c-.002-1.032,1.359-1.691,3.043-1.472h0c1.686,.22,3.056,1.237,3.059,2.272l.085,38.49c.002,1.036-1.365,1.673-3.052,1.423Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.214,494.143l-.015-7.369c-.004-2.052,2.696-3.347,6.04-2.892l5.178,.705c3.368,.459,6.109,2.507,6.114,4.574l.017,7.423c.005,2.067-2.729,3.353-6.098,2.874l-5.179-.737c-3.345-.476-6.053-2.525-6.057-4.577Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.502,546.953h0c-1.455-.255-2.634-1.24-2.634-2.201l-.004-35.717c0-.96,1.178-1.554,2.633-1.325h0c1.457,.229,2.639,1.195,2.639,2.158l.006,35.803c0,.964-1.183,1.538-2.64,1.283Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.036,529.516v-6.857c0-1.909,2.337-3.076,5.227-2.605l4.474,.729c2.91,.474,5.274,2.417,5.275,4.34l.002,6.904c0,1.923-2.364,3.081-5.274,2.589l-4.475-.757c-2.891-.489-5.229-2.433-5.229-4.342Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.099,550.906h0c-1.485-.26-2.688-1.257-2.689-2.229l-.014-36.083c0-.97,1.201-1.568,2.686-1.335h0c1.487,.234,2.694,1.212,2.694,2.184l.016,36.171c0,.973-1.206,1.551-2.694,1.291Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.476,533.277l-.002-6.927c0-1.929,2.384-3.104,5.333-2.623l4.566,.744c2.969,.484,5.383,2.451,5.384,4.393l.004,6.975c0,1.942-2.411,3.109-5.381,2.607l-4.567-.772c-2.95-.499-5.336-2.466-5.337-4.396Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.164,554.94h0c-1.516-.265-2.744-1.275-2.745-2.257l-.024-36.457c0-.98,1.226-1.582,2.741-1.344h0c1.518,.238,2.75,1.229,2.751,2.211l.026,36.547c0,.984-1.231,1.565-2.749,1.3Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.378,537.115l-.004-6.999c-.001-1.949,2.432-3.132,5.443-2.641l4.661,.759c3.031,.494,5.496,2.486,5.497,4.448l.006,7.047c.002,1.963-2.461,3.137-5.492,2.624l-4.662-.788c-3.011-.509-5.447-2.501-5.448-4.45Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.71,559.059h0c-1.548-.271-2.802-1.294-2.803-2.285l-.035-36.839c0-.991,1.251-1.597,2.798-1.353h0c1.549,.244,2.808,1.246,2.809,2.239l.037,36.93c0,.994-1.256,1.58-2.807,1.308Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.757,541.034l-.006-7.072c-.002-1.969,2.482-3.16,5.556-2.66l4.758,.775c3.095,.504,5.612,2.521,5.614,4.504l.008,7.121c.002,1.983-2.512,3.166-5.607,2.642l-4.759-.805c-3.074-.52-5.562-2.537-5.563-4.507Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.753,563.265h0c-1.581-.277-2.862-1.313-2.863-2.315l-.046-37.229c-.001-1.001,1.277-1.611,2.857-1.363h0c1.582,.249,2.868,1.264,2.869,2.268l.048,37.322c.001,1.004-1.283,1.594-2.866,1.317Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.626,545.034l-.008-7.146c-.002-1.99,2.534-3.189,5.672-2.678l4.859,.792c3.161,.515,5.731,2.558,5.734,4.562l.01,7.197c.003,2.004-2.564,3.195-5.725,2.66l-4.86-.822c-3.139-.531-5.68-2.574-5.682-4.564Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.309,567.56h0c-1.615-.282-2.923-1.332-2.925-2.345l-.057-37.627c-.002-1.012,1.304-1.627,2.918-1.373h0c1.616,.254,2.929,1.282,2.931,2.297l.06,37.722c.002,1.015-1.31,1.609-2.927,1.326Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.003,549.119l-.011-7.223c-.003-2.011,2.587-3.219,5.793-2.697l4.964,.809c3.228,.526,5.855,2.595,5.858,4.621l.012,7.275c.003,2.026-2.618,3.224-5.847,2.678l-4.964-.84c-3.206-.542-5.802-2.612-5.805-4.623Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.394,571.948h0c-1.65-.289-2.987-1.352-2.989-2.376l-.069-38.034c-.002-1.023,1.332-1.642,2.98-1.383h0c1.651,.259,2.993,1.301,2.995,2.327l.072,38.131c.002,1.026-1.337,1.624-2.99,1.335Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.904,553.293l-.013-7.3c-.004-2.033,2.642-3.249,5.917-2.716l5.071,.826c3.299,.537,5.983,2.634,5.987,4.681l.014,7.354c.004,2.048-2.674,3.255-5.973,2.697l-5.072-.858c-3.276-.554-5.928-2.65-5.931-4.684Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.025,576.431h0c-1.686-.295-3.053-1.373-3.055-2.407l-.082-38.45c-.002-1.034,1.36-1.658,3.045-1.393h0c1.687,.265,3.059,1.321,3.061,2.357l.085,38.549c.002,1.037-1.366,1.639-3.055,1.344Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.345,557.556l-.015-7.38c-.004-2.055,2.698-3.28,6.045-2.735l5.182,.844c3.371,.549,6.114,2.673,6.119,4.743l.017,7.434c.005,2.07-2.732,3.285-6.103,2.715l-5.183-.877c-3.347-.566-6.058-2.69-6.062-4.746Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.51,606.18h0c-1.457-.294-2.636-1.312-2.636-2.275l-.004-35.768c0-.962,1.179-1.525,2.634-1.257h0c1.458,.268,2.641,1.267,2.641,2.231l.006,35.854c0,.965-1.183,1.508-2.642,1.214Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.039,588.519v-6.866c0-1.912,2.338-3.018,5.23-2.469l4.477,.849c2.912,.552,5.278,2.562,5.278,4.487l.002,6.913c0,1.925-2.365,3.023-5.277,2.452l-4.478-.877c-2.893-.567-5.232-2.576-5.232-4.488Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.124,610.742h0c-1.486-.3-2.69-1.331-2.691-2.304l-.014-36.135c0-.972,1.202-1.538,2.688-1.265h0c1.488,.274,2.696,1.285,2.696,2.259l.016,36.223c0,.975-1.207,1.521-2.696,1.221Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.495,592.885l-.002-6.937c0-1.931,2.386-3.044,5.337-2.485l4.569,.867c2.972,.564,5.387,2.598,5.388,4.543l.004,6.985c.001,1.945-2.413,3.049-5.385,2.467l-4.57-.895c-2.952-.578-5.34-2.612-5.341-4.544Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.205,615.398h0c-1.517-.306-2.746-1.35-2.747-2.333l-.024-36.51c0-.982,1.227-1.552,2.743-1.273h0c1.519,.279,2.752,1.304,2.753,2.288l.026,36.6c0,.985-1.232,1.535-2.751,1.228Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.414,597.34l-.004-7.009c-.001-1.951,2.434-3.071,5.447-2.5l4.664,.885c3.033,.575,5.5,2.636,5.501,4.601l.006,7.058c.002,1.965-2.463,3.076-5.496,2.481l-4.665-.914c-3.013-.59-5.451-2.65-5.452-4.602Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.769,620.151h0c-1.549-.313-2.804-1.37-2.805-2.363l-.035-36.893c0-.992,1.252-1.566,2.801-1.281h0c1.551,.285,2.81,1.323,2.811,2.317l.037,36.985c.001,.995-1.257,1.548-2.809,1.235Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,601.887l-.006-7.082c-.002-1.972,2.484-3.098,5.56-2.515l4.762,.903c3.097,.587,5.616,2.675,5.618,4.661l.008,7.132c.002,1.986-2.513,3.103-5.611,2.496l-4.763-.933c-3.077-.603-5.566-2.689-5.568-4.662Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.831,625.005h0c-1.582-.319-2.864-1.391-2.865-2.394l-.046-37.284c-.001-1.003,1.278-1.58,2.859-1.289h0c1.583,.291,2.87,1.342,2.871,2.347l.048,37.377c.001,1.006-1.284,1.562-2.868,1.242Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.698,606.531l-.008-7.157c-.002-1.993,2.536-3.126,5.677-2.53l4.863,.922c3.163,.6,5.736,2.714,5.739,4.721l.01,7.208c.003,2.007-2.566,3.131-5.729,2.511l-4.864-.953c-3.142-.616-5.684-2.729-5.687-4.723Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.406,629.962h0c-1.616-.326-2.926-1.412-2.927-2.426l-.057-37.683c-.002-1.013,1.305-1.594,2.92-1.297h0c1.617,.298,2.932,1.362,2.933,2.378l.06,37.779c.002,1.017-1.311,1.576-2.929,1.25Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.094,611.273l-.011-7.233c-.003-2.014,2.589-3.155,5.797-2.546l4.967,.942c3.231,.613,5.86,2.755,5.863,4.784l.012,7.285c.003,2.029-2.62,3.159-5.852,2.526l-4.968-.973c-3.209-.629-5.806-2.77-5.809-4.785Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.511,635.026h0c-1.651-.333-2.989-1.434-2.991-2.459l-.069-38.091c-.002-1.024,1.333-1.609,2.983-1.305h0c1.653,.304,2.995,1.383,2.997,2.41l.072,38.189c.002,1.028-1.339,1.59-2.992,1.257Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.014,616.117l-.013-7.311c-.004-2.036,2.644-3.183,5.922-2.562l5.075,.963c3.301,.626,5.987,2.797,5.992,4.848l.014,7.365c.004,2.051-2.676,3.188-5.978,2.541l-5.076-.995c-3.278-.642-5.932-2.813-5.936-4.849Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.163,640.201h0c-1.687-.34-3.055-1.456-3.057-2.493l-.082-38.508c-.002-1.035,1.361-1.624,3.048-1.313h0c1.689,.311,3.061,1.404,3.064,2.442l.085,38.608c.002,1.039-1.367,1.605-3.057,1.264Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.476,621.066l-.015-7.391c-.004-2.058,2.701-3.213,6.05-2.577l5.186,.984c3.374,.64,6.12,2.841,6.124,4.914l.017,7.446c.005,2.074-2.734,3.217-6.108,2.556l-5.187-1.016c-3.35-.656-6.063-2.856-6.067-4.915Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.518,665.491h0c-1.458-.333-2.638-1.384-2.638-2.348l-.004-35.819c0-.963,1.179-1.495,2.636-1.188h0c1.459,.307,2.643,1.34,2.643,2.305l.006,35.905c0,.966-1.184,1.479-2.644,1.145Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.042,647.606v-6.876c0-1.915,2.34-2.96,5.234-2.333l4.48,.97c2.914,.631,5.282,2.706,5.282,4.634l.002,6.923c0,1.928-2.367,2.964-5.281,2.314l-4.481-.998c-2.895-.645-5.236-2.719-5.236-4.634Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.149,670.664h0c-1.488-.34-2.692-1.405-2.693-2.379l-.014-36.187c0-.973,1.203-1.508,2.69-1.195h0c1.489,.314,2.698,1.359,2.698,2.335l.016,36.275c0,.976-1.208,1.491-2.698,1.151Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.514,652.577l-.002-6.947c0-1.934,2.387-2.985,5.341-2.346l4.573,.99c2.974,.644,5.391,2.746,5.392,4.694l.004,6.995c.001,1.948-2.415,2.989-5.389,2.326l-4.573-1.019c-2.954-.658-5.344-2.759-5.345-4.694Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.247,675.943h0c-1.519-.347-2.749-1.426-2.749-2.41l-.024-36.563c0-.983,1.228-1.521,2.745-1.201h0c1.52,.32,2.754,1.379,2.755,2.365l.026,36.653c0,.986-1.233,1.504-2.753,1.157Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.45,657.651l-.004-7.019c-.001-1.954,2.436-3.011,5.451-2.358l4.668,1.011c3.036,.657,5.504,2.787,5.505,4.755l.006,7.068c.002,1.968-2.464,3.014-5.501,2.338l-4.668-1.04c-3.016-.672-5.455-2.8-5.456-4.755Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.829,681.333h0c-1.55-.354-2.806-1.447-2.807-2.442l-.035-36.947c0-.993,1.253-1.534,2.803-1.208h0c1.552,.327,2.812,1.4,2.813,2.396l.037,37.039c.001,.997-1.258,1.517-2.811,1.162Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.863,662.83l-.006-7.092c-.002-1.975,2.486-3.037,5.564-2.37l4.766,1.032c3.1,.671,5.62,2.829,5.622,4.817l.008,7.142c.002,1.989-2.515,3.04-5.615,2.35l-4.767-1.062c-3.079-.686-5.57-2.842-5.572-4.817Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.909,686.837h0c-1.583-.362-2.866-1.47-2.868-2.474l-.046-37.339c-.001-1.004,1.279-1.548,2.862-1.214h0c1.585,.334,2.872,1.421,2.873,2.427l.048,37.433c.001,1.007-1.285,1.53-2.87,1.168Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.77,668.118l-.008-7.167c-.002-1.996,2.538-3.063,5.681-2.382l4.867,1.054c3.166,.685,5.74,2.872,5.743,4.882l.01,7.219c.003,2.01-2.568,3.067-5.734,2.362l-4.868-1.084c-3.144-.7-5.689-2.885-5.691-4.881Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.503,692.458h0c-1.617-.37-2.928-1.492-2.93-2.508l-.057-37.74c-.002-1.015,1.306-1.562,2.922-1.221h0c1.619,.341,2.934,1.443,2.936,2.46l.06,37.835c.002,1.018-1.312,1.543-2.931,1.173Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.184,673.519l-.011-7.244c-.003-2.017,2.591-3.09,5.802-2.395l4.971,1.076c3.234,.7,5.864,2.916,5.868,4.948l.012,7.296c.003,2.032-2.622,3.094-5.856,2.373l-4.972-1.108c-3.212-.715-5.811-2.93-5.814-4.947Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.628,698.2h0c-1.652-.378-2.992-1.516-2.994-2.543l-.069-38.149c-.002-1.026,1.334-1.575,2.985-1.227h0c1.654,.349,2.998,1.465,3,2.494l.072,38.247c.002,1.029-1.34,1.557-2.994,1.179Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.124,679.036l-.013-7.323c-.004-2.039,2.646-3.117,5.926-2.407l5.079,1.1c3.304,.715,5.992,2.961,5.996,5.015l.015,7.376c.004,2.054-2.678,3.121-5.983,2.385l-5.08-1.132c-3.281-.731-5.937-2.975-5.941-5.015Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.301,704.068h0c-1.689-.386-3.058-1.54-3.06-2.578l-.082-38.567c-.002-1.037,1.362-1.59,3.05-1.234h0c1.69,.356,3.064,1.488,3.066,2.528l.085,38.667c.002,1.041-1.368,1.571-3.06,1.184Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.607,684.673l-.015-7.403c-.004-2.061,2.703-3.145,6.055-2.419l5.191,1.124c3.376,.731,6.125,3.008,6.129,5.085l.017,7.457c.005,2.077-2.736,3.149-6.113,2.397l-5.192-1.157c-3.353-.747-6.068-3.022-6.072-5.084Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.527,724.887h0c-1.459-.373-2.64-1.457-2.64-2.422l-.004-35.869c0-.964,1.18-1.466,2.638-1.119h0c1.46,.347,2.645,1.412,2.645,2.379l.006,35.956c0,.968-1.185,1.449-2.646,1.076Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.045,706.776v-6.886c0-1.917,2.342-2.901,5.238-2.197l4.484,1.091c2.916,.71,5.286,2.851,5.286,4.782l.002,6.933c0,1.931-2.369,2.905-5.285,2.177l-4.484-1.119c-2.897-.723-5.24-2.863-5.24-4.78Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.173,730.672h0c-1.489-.38-2.694-1.479-2.695-2.454l-.014-36.239c0-.974,1.204-1.478,2.692-1.125h0c1.49,.354,2.7,1.433,2.7,2.41l.016,36.327c0,.978-1.209,1.461-2.7,1.08Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.534,712.355l-.002-6.957c0-1.937,2.389-2.925,5.345-2.206l4.576,1.114c2.976,.724,5.395,2.894,5.396,4.844l.004,7.005c.001,1.951-2.417,2.929-5.393,2.186l-4.577-1.143c-2.956-.738-5.348-2.906-5.348-4.843Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.289,736.576h0c-1.52-.388-2.751-1.501-2.751-2.487l-.024-36.616c0-.985,1.229-1.49,2.748-1.13h0c1.521,.361,2.756,1.455,2.757,2.442l.027,36.706c0,.988-1.234,1.473-2.755,1.085Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.486,718.049l-.004-7.029c-.001-1.957,2.438-2.95,5.455-2.215l4.671,1.137c3.038,.739,5.508,2.938,5.51,4.909l.006,7.078c.002,1.971-2.466,2.953-5.505,2.194l-4.672-1.166c-3.018-.753-5.459-2.95-5.461-4.907Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.888,742.604h0c-1.552-.396-2.809-1.525-2.81-2.52l-.035-37.001c0-.995,1.254-1.503,2.805-1.135h0c1.553,.369,2.814,1.477,2.815,2.474l.037,37.093c.001,.998-1.259,1.485-2.813,1.089Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.917,723.862l-.006-7.103c-.002-1.978,2.488-2.974,5.568-2.225l4.769,1.161c3.102,.755,5.625,2.983,5.627,4.975l.008,7.153c.002,1.992-2.517,2.978-5.62,2.203l-4.77-1.191c-3.081-.769-5.574-2.995-5.576-4.973Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.987,748.76h0c-1.585-.405-2.869-1.548-2.87-2.555l-.046-37.395c-.001-1.005,1.28-1.516,2.864-1.14h0c1.586,.377,2.874,1.5,2.876,2.508l.049,37.488c.001,1.009-1.286,1.498-2.872,1.093Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.841,729.797l-.008-7.178c-.002-1.999,2.54-3,5.686-2.234l4.871,1.185c3.168,.771,5.745,3.029,5.748,5.042l.01,7.229c.003,2.013-2.57,3.003-5.738,2.212l-4.872-1.216c-3.147-.785-5.693-3.041-5.695-5.041Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.6,755.047h0c-1.619-.413-2.93-1.573-2.932-2.59l-.057-37.796c-.002-1.016,1.307-1.529,2.925-1.145h0c1.62,.385,2.936,1.523,2.938,2.542l.06,37.892c.002,1.02-1.313,1.51-2.934,1.096Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.275,735.859l-.011-7.255c-.003-2.02,2.593-3.025,5.806-2.243l4.975,1.211c3.236,.788,5.869,3.077,5.872,5.112l.012,7.307c.003,2.035-2.624,3.028-5.861,2.22l-4.976-1.242c-3.214-.802-5.815-3.089-5.818-5.11Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.745,761.47h0c-1.654-.422-2.994-1.598-2.996-2.626l-.069-38.207c-.002-1.027,1.335-1.542,2.988-1.149h0c1.655,.393,3,1.547,3.002,2.577l.072,38.305c.002,1.031-1.341,1.523-2.997,1.1Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.235,742.051l-.013-7.334c-.004-2.042,2.648-3.051,5.931-2.252l5.083,1.237c3.307,.805,5.997,3.126,6.001,5.183l.015,7.387c.004,2.057-2.68,3.054-5.987,2.229l-5.084-1.269c-3.284-.82-5.942-3.138-5.946-5.181Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.439,768.033h0c-1.69-.432-3.06-1.624-3.062-2.664l-.082-38.626c-.002-1.039,1.364-1.556,3.053-1.154h0c1.692,.402,3.066,1.572,3.069,2.614l.085,38.726c.002,1.042-1.37,1.536-3.062,1.104Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.738,748.377l-.015-7.414c-.004-2.064,2.705-3.077,6.06-2.261l5.195,1.264c3.379,.822,6.13,3.177,6.134,5.256l.017,7.469c.005,2.08-2.738,3.08-6.118,2.237l-5.196-1.297c-3.356-.838-6.073-3.189-6.077-5.254Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.535,784.367h0c-1.46-.412-2.642-1.53-2.642-2.496l-.004-35.92c0-.966,1.181-1.436,2.64-1.051h0c1.461,.386,2.647,1.485,2.647,2.453l.006,36.007c0,.969-1.186,1.42-2.648,1.007Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.048,766.03v-6.896c0-1.92,2.343-2.843,5.242-2.06l4.487,1.213c2.918,.789,5.289,2.997,5.29,4.93l.002,6.943c0,1.934-2.37,2.845-5.289,2.038l-4.487-1.241c-2.899-.802-5.243-3.007-5.244-4.927Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.198,790.766h0c-1.49-.421-2.696-1.553-2.697-2.53l-.014-36.291c0-.976,1.205-1.448,2.694-1.054h0c1.491,.394,2.702,1.507,2.702,2.486l.016,36.379c0,.979-1.21,1.431-2.702,1.01Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.553,772.219l-.002-6.967c0-1.94,2.391-2.866,5.349-2.066l4.579,1.238c2.978,.805,5.399,3.042,5.4,4.996l.004,7.015c.001,1.954-2.419,2.868-5.397,2.044l-4.58-1.267c-2.959-.818-5.352-3.053-5.352-4.993Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.331,797.297h0c-1.521-.429-2.753-1.577-2.753-2.564l-.024-36.669c0-.986,1.23-1.46,2.75-1.058h0c1.522,.403,2.758,1.531,2.759,2.519l.027,36.76c0,.989-1.235,1.442-2.758,1.012Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.522,778.535l-.004-7.039c-.001-1.96,2.44-2.889,5.459-2.073l4.675,1.263c3.04,.822,5.512,3.089,5.514,5.063l.006,7.088c.002,1.974-2.468,2.891-5.509,2.05l-4.675-1.293c-3.02-.835-5.463-3.1-5.465-5.06Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.948,803.965h0c-1.553-.438-2.811-1.602-2.812-2.599l-.035-37.055c0-.996,1.255-1.472,2.807-1.061h0c1.554,.411,2.816,1.554,2.817,2.553l.037,37.148c.001,1-1.26,1.454-2.815,1.015Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.97,784.983l-.006-7.113c-.002-1.981,2.49-2.912,5.573-2.079l4.773,1.29c3.104,.839,5.629,3.138,5.631,5.132l.008,7.164c.002,1.995-2.519,2.915-5.624,2.056l-4.774-1.32c-3.084-.853-5.579-3.148-5.58-5.129Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.065,810.775h0c-1.586-.448-2.871-1.627-2.872-2.635l-.046-37.45c-.001-1.007,1.281-1.484,2.866-1.065h0c1.587,.42,2.876,1.579,2.878,2.588l.049,37.544c.001,1.01-1.287,1.466-2.875,1.017Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.913,791.567l-.008-7.189c-.002-2.002,2.542-2.936,5.69-2.085l4.874,1.317c3.17,.857,5.749,3.187,5.752,5.203l.01,7.24c.003,2.016-2.572,2.938-5.743,2.061l-4.875-1.348c-3.149-.871-5.697-3.198-5.7-5.2Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.697,817.73h0c-1.62-.457-2.933-1.654-2.934-2.672l-.058-37.853c-.002-1.018,1.308-1.496,2.927-1.068h0c1.621,.429,2.939,1.604,2.94,2.624l.06,37.949c.002,1.021-1.314,1.478-2.936,1.02Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.366,798.291l-.011-7.266c-.003-2.023,2.595-2.96,5.811-2.091l4.979,1.346c3.239,.875,5.874,3.239,5.877,5.276l.012,7.318c.003,2.038-2.626,2.962-5.866,2.067l-4.98-1.377c-3.217-.89-5.82-3.249-5.823-5.273Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.863,824.835h0c-1.655-.467-2.997-1.681-2.998-2.71l-.07-38.265c-.002-1.029,1.336-1.509,2.99-1.071h0c1.657,.438,3.003,1.63,3.005,2.661l.073,38.363c.002,1.032-1.342,1.49-2.999,1.022Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.346,805.16l-.013-7.345c-.004-2.045,2.65-2.985,5.936-2.097l5.087,1.375c3.309,.894,6.002,3.291,6.006,5.351l.015,7.398c.004,2.06-2.683,2.987-5.992,2.072l-5.088-1.407c-3.286-.909-5.947-3.302-5.95-5.348Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.578,832.096h0c-1.691-.478-3.063-1.708-3.065-2.749l-.082-38.685c-.002-1.04,1.365-1.521,3.055-1.074h0c1.693,.448,3.069,1.657,3.071,2.699l.085,38.786c.002,1.044-1.371,1.502-3.065,1.024Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.869,812.178l-.015-7.425c-.004-2.067,2.707-3.01,6.065-2.102l5.199,1.405c3.382,.914,6.135,3.345,6.139,5.428l.017,7.48c.005,2.083-2.741,3.012-6.123,2.076l-5.2-1.438c-3.358-.929-6.078-3.356-6.082-5.424Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "489.36 558.68 314.28 558.68 0 514.84 148.26 514.84 489.36 558.68",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.28,
    y: 558.68,
    width: 175.08,
    height: 10.69,
    fill: "#f2c2a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.28 558.68 314.28 569.37 0 523.89 0 514.84 314.28 558.68",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "328.16 519.02 328.16 554.26 286.72 548.67 286.72 514.13 328.16 519.02",
    fill: "#262929"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.14 509.37 370.14 519.02 328.16 519.02 286.72 514.13 286.72 500.11 370.14 509.37",
    fill: "#474c49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.11 519.02 370.14 519.02 370.14 509.37 428.62 515.86 457.11 519.02",
    fill: "#474c49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.16 383.88 328.16 419.12 286.72 416.24 286.72 381.71 328.16 383.88",
    fill: "#262929"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.11 383.88 328.16 383.88 286.72 381.71 286.72 375.46 457.11 383.88",
    fill: "#474c49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.16,
    y: 519.02,
    width: 128.95,
    height: 35.24,
    fill: "#33312f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.14,
    y: 509.28,
    width: 58.48,
    height: 9.75,
    fill: "#f8c800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.888,
    y: 409.871,
    width: 6.748,
    height: 81.972,
    fill: "#a5a095"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.439,
    y: 409.871,
    width: 1.749,
    height: 81.972,
    fill: "#e5ddcf"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.141,
    y: 490.093,
    width: 19.761,
    height: 18.993,
    fill: "#e5ddcf"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.16,
    y: 383.88,
    width: 128.95,
    height: 35.24,
    fill: "#2f3331"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.904,
    y: 397.375,
    width: 24.242,
    height: 18.993,
    fill: "#262929"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "303.72 0 303.72 923.77 93.5 835.31 93.5 37.01 303.72 0",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.97,
    width: 11.499,
    height: 923.77,
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.872,109.354h0c-1.412,.215-2.554-.425-2.554-1.431v-37.38c0-1.006,1.142-2.026,2.554-2.28h0c1.414-.254,2.563,.357,2.563,1.366v37.506c0,1.009-1.148,2.002-2.563,2.218Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.641,93.595v-7.169c0-1.996,2.263-4.002,5.063-4.481l4.342-.742c2.827-.483,5.127,.758,5.127,2.773v7.239c0,2.016-2.3,4.021-5.127,4.477l-4.342,.701c-2.801,.452-5.064-.801-5.064-2.798Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.888,105.994h0c-1.453,.222-2.629-.426-2.629-1.446v-37.922c0-1.02,1.176-2.058,2.629-2.32h0c1.456-.262,2.638,.356,2.638,1.379v38.052c0,1.024-1.182,2.034-2.638,2.256Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445,90.024v-7.273c0-2.025,2.329-4.065,5.211-4.558l4.469-.764c2.91-.498,5.278,.756,5.278,2.801v7.344c0,2.045-2.367,4.085-5.277,4.555l-4.469,.721c-2.883,.465-5.212-.801-5.212-2.826Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.553,102.536h0c-1.496,.228-2.707-.426-2.707-1.461V62.594c0-1.035,1.211-2.092,2.707-2.361h0c1.499-.269,2.716,.354,2.716,1.393v38.614c0,1.039-1.217,2.067-2.716,2.295Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,86.348v-7.38c0-2.055,2.398-4.131,5.366-4.638l4.602-.787c2.997-.512,5.435,.753,5.435,2.829v7.453c0,2.075-2.438,4.151-5.435,4.635l-4.602,.743c-2.968,.479-5.366-.8-5.366-2.855Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.897,98.973h0c-1.541,.235-2.788-.426-2.788-1.477V58.441c0-1.051,1.247-2.126,2.788-2.403h0c1.544-.278,2.798,.352,2.798,1.406v39.193c0,1.054-1.254,2.1-2.798,2.336Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.003,82.562v-7.49c0-2.086,2.47-4.199,5.527-4.721l4.74-.81c3.088-.528,5.6,.751,5.6,2.857v7.565c0,2.107-2.512,4.22-5.599,4.718l-4.74,.765c-3.057,.494-5.527-.799-5.527-2.884Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.95,95.303h0c-1.588,.242-2.874-.426-2.874-1.493V54.162c0-1.067,1.285-2.162,2.874-2.448h0c1.591-.286,2.884,.349,2.884,1.42v39.79c0,1.07-1.293,2.135-2.884,2.378Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.815,78.662v-7.603c0-2.117,2.545-4.269,5.696-4.807l4.885-.835c3.182-.544,5.772,.747,5.772,2.886v7.681c0,2.139-2.589,4.291-5.771,4.804l-4.885,.789c-3.151,.509-5.696-.797-5.696-2.914Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.745,91.519h0c-1.638,.25-2.963-.426-2.963-1.509V49.751c0-1.083,1.325-2.199,2.963-2.493h0c1.641-.295,2.974,.347,2.974,1.434v40.405c0,1.087-1.333,2.171-2.974,2.422Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,74.642v-7.72c0-2.15,2.624-4.341,5.872-4.896l5.037-.861c3.282-.561,5.952,.743,5.952,2.915v7.8c0,2.172-2.67,4.364-5.951,4.893l-5.037,.813c-3.248,.524-5.872-.795-5.872-2.945Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.317,87.616h0c-1.689,.258-3.056-.425-3.056-1.525V45.203c0-1.1,1.367-2.237,3.056-2.541h0c1.693-.304,3.068,.344,3.068,1.448v41.04c0,1.104-1.375,2.209-3.068,2.467Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.666,70.497v-7.84c0-2.183,2.706-4.416,6.057-4.989l5.197-.888c3.386-.579,6.14,.739,6.14,2.945v7.923c0,2.206-2.755,4.439-6.14,4.986l-5.197,.839c-3.351,.541-6.057-.792-6.057-2.975Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.704,83.589h0c-1.744,.266-3.154-.424-3.154-1.542V40.509c0-1.117,1.411-2.277,3.154-2.59h0c1.747-.314,3.166,.34,3.166,1.462v41.694c0,1.122-1.419,2.247-3.166,2.514Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.776,66.22v-7.964c0-2.218,2.793-4.493,6.251-5.084l5.363-.917c3.495-.597,6.338,.734,6.338,2.975v8.05c0,2.242-2.843,4.518-6.338,5.082l-5.363,.866c-3.458,.558-6.251-.789-6.251-3.007Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.872,171.295h0c-1.412,.158-2.554-.53-2.554-1.535v-37.38c0-1.006,1.142-1.979,2.554-2.175h0c1.414-.196,2.563,.462,2.563,1.471v37.506c0,1.009-1.148,1.955-2.563,2.113Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.641,155.241v-7.169c0-1.996,2.263-3.909,5.063-4.273l4.342-.565c2.827-.368,5.127,.967,5.127,2.983v7.239c0,2.016-2.3,3.927-5.127,4.268l-4.342,.523c-2.801,.338-5.064-1.008-5.064-3.005Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.888,168.836h0c-1.453,.162-2.629-.533-2.629-1.553v-37.922c0-1.02,1.176-2.01,2.629-2.212h0c1.456-.202,2.638,.464,2.638,1.487v38.052c0,1.024-1.182,1.986-2.638,2.148Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445,152.561v-7.273c0-2.025,2.329-3.97,5.211-4.345l4.469-.581c2.91-.379,5.278,.971,5.278,3.017v7.344c0,2.045-2.367,3.988-5.277,4.339l-4.469,.539c-2.883,.347-5.212-1.014-5.212-3.039Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.553,166.304h0c-1.496,.167-2.707-.537-2.707-1.572v-38.48c0-1.035,1.211-2.042,2.707-2.25h0c1.499-.208,2.716,.465,2.716,1.504v38.614c0,1.039-1.217,2.017-2.716,2.184Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,149.803v-7.38c0-2.055,2.398-4.033,5.366-4.419l4.602-.599c2.997-.39,5.435,.976,5.435,3.051v7.453c0,2.075-2.438,4.052-5.435,4.413l-4.602,.555c-2.968,.358-5.366-1.019-5.366-3.074Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.896,163.696h0c-1.541,.172-2.788-.54-2.788-1.591v-39.055c0-1.051,1.247-2.075,2.788-2.289h0c1.544-.214,2.798,.466,2.798,1.521v39.193c0,1.054-1.254,2.049-2.798,2.222Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.003,146.962v-7.49c0-2.086,2.47-4.098,5.527-4.495l4.74-.617c3.088-.402,5.6,.979,5.6,3.086v7.565c0,2.107-2.512,4.117-5.599,4.489l-4.74,.571c-3.057,.368-5.527-1.025-5.527-3.11Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.949,161.009h0c-1.588,.177-2.874-.544-2.874-1.61v-39.648c0-1.067,1.285-2.11,2.874-2.33h0c1.591-.221,2.884,.467,2.884,1.538v39.79c0,1.07-1.293,2.082-2.884,2.26Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.814,144.035v-7.603c0-2.117,2.545-4.164,5.696-4.574l4.885-.635c3.182-.414,5.772,.983,5.772,3.122v7.681c0,2.139-2.589,4.185-5.771,4.568l-4.885,.589c-3.151,.38-5.696-1.03-5.696-3.147Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.745,158.239h0c-1.638,.183-2.963-.547-2.963-1.63v-40.258c0-1.083,1.325-2.145,2.963-2.372h0c1.641-.228,2.974,.468,2.974,1.555v40.405c0,1.087-1.333,2.117-2.974,2.3Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,141.019v-7.72c0-2.15,2.624-4.234,5.872-4.656l5.037-.655c3.282-.427,5.952,.987,5.952,3.159v7.8c0,2.172-2.67,4.255-5.951,4.65l-5.037,.607c-3.248,.392-5.872-1.035-5.872-3.185Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.317,155.382h0c-1.689,.189-3.056-.55-3.056-1.65v-40.888c0-1.1,1.367-2.181,3.056-2.416h0c1.693-.235,3.068,.469,3.068,1.573v41.04c0,1.104-1.375,2.153-3.068,2.342Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.666,137.909v-7.84c0-2.183,2.706-4.305,6.057-4.741l5.197-.676c3.386-.44,6.14,.99,6.14,3.196v7.923c0,2.206-2.755,4.327-6.14,4.735l-5.197,.626c-3.351,.404-6.057-1.04-6.057-3.223Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.704,152.434h0c-1.744,.195-3.154-.553-3.154-1.671v-41.538c0-1.117,1.411-2.219,3.154-2.461h0c1.747-.243,3.166,.47,3.166,1.591v41.694c0,1.122-1.419,2.189-3.166,2.385Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.776,134.7v-7.964c0-2.218,2.793-4.379,6.251-4.829l5.363-.698c3.495-.455,6.338,.993,6.338,3.234v8.05c0,2.242-2.843,4.401-6.338,4.822l-5.363,.646c-3.458,.417-6.251-1.045-6.251-3.262Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.872,233.236h0c-1.412,.1-2.554-.634-2.554-1.64v-37.38c0-1.006,1.142-1.933,2.554-2.071h0c1.414-.139,2.563,.567,2.563,1.576v37.506c0,1.009-1.148,1.908-2.563,2.008Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.641,216.886v-7.169c0-1.996,2.263-3.817,5.063-4.066l4.342-.387c2.827-.252,5.127,1.177,5.127,3.193v7.239c0,2.016-2.3,3.833-5.127,4.058l-4.342,.346c-2.801,.223-5.064-1.215-5.064-3.212Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.888,231.677h0c-1.453,.103-2.629-.641-2.629-1.661v-37.922c0-1.02,1.176-1.962,2.629-2.105h0c1.456-.143,2.638,.571,2.638,1.595v38.052c0,1.024-1.182,1.937-2.638,2.04Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445,215.098v-7.273c0-2.025,2.329-3.875,5.211-4.132l4.469-.399c2.91-.26,5.278,1.187,5.278,3.232v7.344c0,2.045-2.367,3.891-5.277,4.123l-4.469,.356c-2.883,.23-5.212-1.227-5.212-3.252Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.553,230.072h0c-1.496,.106-2.707-.647-2.707-1.683v-38.48c0-1.035,1.211-1.993,2.707-2.139h0c1.499-.147,2.716,.576,2.716,1.615v38.614c0,1.039-1.217,1.967-2.716,2.073Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,213.257v-7.38c0-2.055,2.398-3.935,5.366-4.199l4.602-.41c2.997-.267,5.435,1.198,5.435,3.273v7.453c0,2.075-2.438,3.952-5.435,4.191l-4.602,.366c-2.968,.236-5.366-1.239-5.366-3.294Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.896,228.418h0c-1.541,.109-2.788-.654-2.788-1.705v-39.055c0-1.051,1.247-2.024,2.788-2.175h0c1.544-.151,2.798,.581,2.798,1.635v39.193c0,1.054-1.254,1.998-2.798,2.107Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.003,211.362v-7.49c0-2.086,2.47-3.997,5.527-4.269l4.74-.423c3.088-.275,5.6,1.208,5.6,3.315v7.565c0,2.107-2.512,4.014-5.599,4.26l-4.74,.377c-3.057,.243-5.527-1.251-5.527-3.336Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.949,226.715h0c-1.588,.112-2.874-.661-2.874-1.728v-39.648c0-1.067,1.285-2.057,2.874-2.213h0c1.591-.156,2.884,.585,2.884,1.656v39.79c0,1.07-1.293,2.03-2.884,2.142Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.814,209.409v-7.603c0-2.117,2.545-4.06,5.696-4.341l4.885-.436c3.182-.284,5.772,1.219,5.772,3.358v7.681c0,2.139-2.589,4.079-5.771,4.332l-4.885,.389c-3.151,.251-5.696-1.263-5.696-3.38Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.745,224.958h0c-1.638,.116-2.963-.668-2.963-1.751v-40.258c0-1.083,1.325-2.091,2.963-2.251h0c1.641-.161,2.974,.59,2.974,1.677v40.405c0,1.087-1.333,2.062-2.974,2.179Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,207.396v-7.72c0-2.15,2.624-4.126,5.872-4.416l5.037-.449c3.282-.293,5.952,1.23,5.952,3.402v7.8c0,2.172-2.67,4.145-5.951,4.407l-5.037,.401c-3.248,.259-5.872-1.275-5.872-3.425Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.317,223.147h0c-1.689,.12-3.056-.675-3.056-1.775v-40.888c0-1.1,1.367-2.125,3.056-2.291h0c1.693-.166,3.068,.594,3.068,1.698v41.04c0,1.104-1.375,2.096-3.068,2.216Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.666,205.32v-7.84c0-2.183,2.706-4.194,6.057-4.493l5.197-.463c3.386-.302,6.14,1.241,6.14,3.447v7.923c0,2.206-2.755,4.214-6.14,4.484l-5.197,.414c-3.351,.267-6.057-1.288-6.057-3.471Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.704,221.278h0c-1.744,.123-3.154-.682-3.154-1.8v-41.538c0-1.117,1.411-2.161,3.154-2.332h0c1.747-.171,3.166,.599,3.166,1.721v41.694c0,1.122-1.419,2.131-3.166,2.255Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.775,203.179v-7.964c0-2.218,2.793-4.265,6.251-4.573l5.363-.478c3.495-.312,6.338,1.252,6.338,3.494v8.05c0,2.242-2.843,4.285-6.338,4.563l-5.363,.427c-3.458,.275-6.251-1.3-6.251-3.518Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.872,295.177h0c-1.412,.042-2.554-.739-2.554-1.744v-37.38c0-1.006,1.142-1.886,2.554-1.966h0c1.414-.081,2.563,.672,2.563,1.681v37.506c0,1.009-1.148,1.861-2.563,1.904Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.641,278.531v-7.169c0-1.996,2.263-3.724,5.063-3.859l4.342-.21c2.827-.137,5.127,1.386,5.127,3.402v7.239c0,2.016-2.3,3.739-5.127,3.848l-4.342,.168c-2.801,.109-5.064-1.422-5.064-3.419Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.888,294.518h0c-1.453,.043-2.629-.748-2.629-1.768v-37.922c0-1.02,1.176-1.914,2.629-1.997h0c1.456-.083,2.638,.679,2.638,1.703v38.052c0,1.024-1.182,1.889-2.638,1.932Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445,277.635v-7.273c0-2.025,2.329-3.78,5.211-3.919l4.469-.216c2.91-.141,5.278,1.403,5.278,3.448v7.344c0,2.045-2.367,3.795-5.277,3.907l-4.469,.173c-2.883,.112-5.212-1.44-5.212-3.465Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.553,293.84h0c-1.496,.045-2.707-.758-2.707-1.793v-38.48c0-1.035,1.211-1.943,2.707-2.029h0c1.499-.086,2.716,.687,2.716,1.726v38.614c0,1.039-1.217,1.917-2.716,1.962Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,276.712v-7.38c0-2.055,2.398-3.837,5.366-3.98l4.602-.222c2.997-.145,5.435,1.42,5.435,3.496v7.453c0,2.075-2.438,3.852-5.435,3.968l-4.602,.178c-2.968,.115-5.366-1.458-5.366-3.513Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.896,293.141h0c-1.541,.046-2.788-.768-2.788-1.819v-39.055c0-1.051,1.247-1.973,2.788-2.061h0c1.544-.088,2.798,.695,2.798,1.749v39.193c0,1.054-1.254,1.947-2.798,1.993Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.003,275.761v-7.49c0-2.086,2.47-3.896,5.527-4.043l4.74-.229c3.088-.149,5.6,1.437,5.6,3.544v7.565c0,2.107-2.512,3.912-5.599,4.031l-4.74,.184c-3.057,.118-5.527-1.477-5.527-3.562Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.949,292.421h0c-1.588,.048-2.874-.779-2.874-1.845v-39.648c0-1.067,1.285-2.005,2.874-2.095h0c1.591-.091,2.884,.703,2.884,1.774v39.79c0,1.07-1.292,1.977-2.884,2.024Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.814,274.782v-7.603c0-2.117,2.545-3.956,5.696-4.109l4.885-.236c3.182-.154,5.772,1.455,5.772,3.594v7.681c0,2.139-2.589,3.973-5.771,4.096l-4.885,.189c-3.151,.122-5.696-1.496-5.696-3.613Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.745,291.678h0c-1.638,.049-2.963-.789-2.963-1.872v-40.258c0-1.083,1.325-2.037,2.963-2.13h0c1.641-.094,2.974,.711,2.974,1.798v40.405c0,1.087-1.333,2.008-2.974,2.057Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,273.773v-7.72c0-2.15,2.624-4.019,5.872-4.176l5.037-.243c3.282-.158,5.952,1.473,5.952,3.645v7.8c0,2.172-2.67,4.036-5.951,4.163l-5.037,.195c-3.248,.126-5.872-1.515-5.872-3.665Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.317,290.913h0c-1.689,.051-3.056-.8-3.056-1.9v-40.888c0-1.1,1.367-2.07,3.056-2.166h0c1.693-.097,3.068,.72,3.068,1.824v41.04c0,1.104-1.375,2.04-3.068,2.091Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.666,272.732v-7.84c0-2.183,2.706-4.084,6.057-4.245l5.197-.251c3.386-.164,6.14,1.492,6.14,3.698v7.923c0,2.206-2.755,4.101-6.14,4.233l-5.197,.201c-3.351,.13-6.057-1.535-6.057-3.718Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.704,290.123h0c-1.744,.052-3.154-.811-3.154-1.929v-41.538c0-1.117,1.411-2.104,3.154-2.203h0c1.747-.1,3.166,.729,3.166,1.85v41.694c0,1.122-1.419,2.073-3.166,2.126Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.775,271.659v-7.964c0-2.218,2.793-4.15,6.251-4.317l5.363-.259c3.495-.169,6.338,1.511,6.338,3.753v8.05c0,2.242-2.843,4.169-6.338,4.304l-5.363,.208c-3.458,.134-6.251-1.556-6.251-3.774Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.872,357.118h0c-1.412-.015-2.554-.843-2.554-1.849v-37.38c0-1.006,1.142-1.839,2.554-1.862h0c1.414-.023,2.563,.776,2.563,1.785v37.506c0,1.009-1.148,1.814-2.563,1.799Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.641,340.177v-7.169c0-1.996,2.263-3.632,5.063-3.652l4.342-.032c2.827-.021,5.127,1.596,5.127,3.612v7.239c0,2.016-2.3,3.645-5.127,3.639l-4.342-.009c-2.801-.006-5.064-1.629-5.064-3.626Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.888,357.359h0c-1.453-.016-2.629-.856-2.629-1.876v-37.922c0-1.02,1.176-1.866,2.629-1.89h0c1.456-.024,2.638,.787,2.638,1.811v38.052c0,1.024-1.182,1.841-2.638,1.825Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445,340.172v-7.273c0-2.025,2.329-3.684,5.211-3.706l4.469-.033c2.91-.022,5.278,1.619,5.278,3.664v7.344c0,2.045-2.367,3.698-5.277,3.692l-4.469-.01c-2.883-.006-5.212-1.653-5.212-3.678Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.553,357.608h0c-1.496-.016-2.707-.869-2.707-1.904v-38.48c0-1.035,1.211-1.894,2.707-1.918h0c1.499-.024,2.716,.798,2.716,1.837v38.614c0,1.039-1.217,1.868-2.716,1.851Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.889,340.166v-7.38c0-2.055,2.398-3.739,5.366-3.761l4.602-.034c2.997-.022,5.435,1.642,5.435,3.718v7.453c0,2.075-2.438,3.753-5.435,3.746l-4.602-.01c-2.968-.006-5.366-1.678-5.366-3.733Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.896,357.863h0c-1.541-.017-2.788-.882-2.788-1.933v-39.055c0-1.051,1.247-1.922,2.788-1.947h0c1.544-.025,2.798,.809,2.798,1.864v39.193c0,1.054-1.254,1.895-2.798,1.878Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.002,340.161v-7.49c0-2.086,2.47-3.795,5.527-3.817l4.74-.035c3.088-.023,5.6,1.666,5.6,3.773v7.565c0,2.107-2.512,3.809-5.599,3.802l-4.74-.01c-3.057-.007-5.527-1.703-5.527-3.788Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.949,358.127h0c-1.588-.017-2.874-.896-2.874-1.963v-39.648c0-1.067,1.285-1.952,2.874-1.978h0c1.591-.026,2.884,.821,2.884,1.891v39.79c0,1.07-1.292,1.924-2.884,1.907Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.814,340.156v-7.603c0-2.117,2.545-3.852,5.696-3.876l4.885-.036c3.182-.024,5.772,1.691,5.772,3.83v7.681c0,2.139-2.589,3.867-5.771,3.86l-4.885-.01c-3.151-.007-5.696-1.729-5.696-3.846Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.745,358.398h0c-1.638-.018-2.963-.91-2.963-1.993v-40.258c0-1.083,1.325-1.982,2.963-2.009h0c1.641-.027,2.974,.833,2.974,1.92v40.405c0,1.087-1.333,1.953-2.974,1.935Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,340.15v-7.72c0-2.15,2.624-3.912,5.872-3.936l5.037-.037c3.282-.024,5.952,1.717,5.952,3.889v7.8c0,2.172-2.67,3.927-5.951,3.92l-5.037-.011c-3.248-.007-5.872-1.755-5.872-3.905Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.317,358.678h0c-1.689-.019-3.056-.925-3.056-2.025v-40.888c0-1.1,1.367-2.014,3.056-2.041h0c1.693-.027,3.068,.845,3.068,1.949v41.04c0,1.104-1.375,1.984-3.068,1.965Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.665,340.144v-7.84c0-2.183,2.706-3.973,6.057-3.998l5.197-.038c3.386-.025,6.14,1.743,6.14,3.949v7.923c0,2.206-2.755,3.989-6.14,3.982l-5.197-.011c-3.351-.007-6.057-1.783-6.057-3.966Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.704,358.968h0c-1.744-.019-3.154-.94-3.154-2.058v-41.538c0-1.117,1.411-2.046,3.154-2.074h0c1.747-.028,3.166,.858,3.166,1.98v41.694c0,1.122-1.419,2.015-3.166,1.996Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.775,340.138v-7.964c0-2.218,2.793-4.036,6.251-4.062l5.363-.04c3.495-.026,6.338,1.77,6.338,4.012v8.05c0,2.242-2.843,4.053-6.338,4.045l-5.363-.012c-3.458-.007-6.251-1.811-6.251-4.029Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.872,419.059h0c-1.412-.073-2.554-.948-2.554-1.953v-37.38c0-1.006,1.142-1.792,2.554-1.758h0c1.414,.035,2.563,.881,2.563,1.89v37.506c0,1.009-1.148,1.767-2.563,1.694Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.641,401.822v-7.169c0-1.996,2.263-3.539,5.063-3.445l4.342,.145c2.827,.095,5.127,1.806,5.127,3.822v7.239c0,2.016-2.3,3.551-5.127,3.429l-4.342-.187c-2.801-.121-5.064-1.836-5.064-3.833Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.888,420.2h0c-1.453-.075-2.629-.963-2.629-1.983v-37.922c0-1.02,1.176-1.818,2.629-1.782h0c1.456,.036,2.638,.895,2.638,1.919v38.052c0,1.024-1.182,1.792-2.638,1.717Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445,402.708v-7.273c0-2.025,2.329-3.589,5.211-3.493l4.469,.15c2.91,.097,5.278,1.835,5.278,3.88v7.344c0,2.045-2.367,3.601-5.277,3.476l-4.469-.192c-2.883-.124-5.212-1.866-5.212-3.892Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.553,421.375h0c-1.496-.078-2.707-.979-2.707-2.015v-38.48c0-1.035,1.211-1.844,2.707-1.807h0c1.499,.037,2.716,.909,2.716,1.948v38.614c0,1.039-1.217,1.818-2.716,1.74Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.889,403.621v-7.38c0-2.055,2.398-3.641,5.366-3.541l4.602,.154c2.997,.1,5.435,1.865,5.435,3.94v7.453c0,2.075-2.438,3.653-5.435,3.524l-4.602-.198c-2.968-.128-5.366-1.897-5.366-3.952Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.896,422.586h0c-1.541-.08-2.788-.996-2.788-2.047v-39.055c0-1.051,1.247-1.871,2.788-1.833h0c1.544,.038,2.798,.924,2.798,1.978v39.193c0,1.054-1.254,1.844-2.798,1.764Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.002,404.561v-7.49c0-2.086,2.47-3.694,5.527-3.591l4.74,.159c3.088,.103,5.6,1.895,5.6,4.002v7.565c0,2.107-2.512,3.706-5.599,3.573l-4.74-.204c-3.057-.132-5.527-1.929-5.527-4.014Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.949,423.833h0c-1.588-.082-2.874-1.014-2.874-2.08v-39.648c0-1.067,1.285-1.899,2.874-1.86h0c1.591,.039,2.884,.939,2.884,2.009v39.79c0,1.07-1.292,1.871-2.884,1.789Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.814,405.529v-7.603c0-2.117,2.545-3.748,5.696-3.643l4.885,.164c3.182,.107,5.772,1.927,5.772,4.066v7.681c0,2.139-2.589,3.761-5.771,3.624l-4.885-.21c-3.151-.136-5.696-1.962-5.696-4.079Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.745,425.118h0c-1.638-.085-2.963-1.032-2.963-2.115v-40.258c0-1.083,1.325-1.928,2.963-1.888h0c1.641,.041,2.974,.955,2.974,2.042v40.405c0,1.087-1.333,1.899-2.974,1.814Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.357,406.527v-7.72c0-2.15,2.624-3.804,5.872-3.696l5.037,.169c3.282,.11,5.952,1.96,5.952,4.132v7.8c0,2.172-2.67,3.818-5.951,3.677l-5.037-.217c-3.248-.14-5.872-1.995-5.872-4.145Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.317,426.444h0c-1.689-.088-3.056-1.05-3.056-2.15v-40.888c0-1.1,1.367-1.958,3.056-1.916h0c1.693,.042,3.068,.971,3.068,2.075v41.04c0,1.104-1.375,1.928-3.068,1.84Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.665,407.556v-7.84c0-2.183,2.706-3.862,6.057-3.75l5.197,.174c3.386,.113,6.14,1.994,6.14,4.201v7.923c0,2.206-2.755,3.876-6.14,3.73l-5.197-.224c-3.351-.144-6.057-2.031-6.057-4.214Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.704,427.812h0c-1.744-.09-3.154-1.069-3.154-2.187v-41.538c0-1.117,1.411-1.988,3.154-1.945h0c1.747,.043,3.166,.988,3.166,2.109v41.694c0,1.122-1.419,1.957-3.166,1.867Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.775,408.618v-7.964c0-2.218,2.793-3.922,6.251-3.806l5.363,.18c3.495,.117,6.338,2.029,6.338,4.271v8.05c0,2.242-2.843,3.936-6.338,3.786l-5.363-.231c-3.458-.149-6.251-2.067-6.251-4.285Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.481,496.7h0c-1.481-.146-2.681-1.057-2.681-2.035l-.004-36.361c0-.978,1.199-1.669,2.68-1.543h0c1.482,.126,2.685,1.021,2.685,2.001l.006,36.427c0,.98-1.203,1.657-2.686,1.511Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.878,479.522v-6.984c0-1.945,2.381-3.309,5.324-3.047l4.553,.406c2.958,.264,5.361,2.062,5.362,4.017l.002,7.02c0,1.955-2.402,3.315-5.361,3.037l-4.554-.427c-2.944-.276-5.326-2.077-5.326-4.022Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.421,498.953h0c-1.504-.148-2.723-1.067-2.724-2.053l-.014-36.644c0-.985,1.217-1.681,2.721-1.553h0c1.505,.128,2.727,1.031,2.727,2.018l.016,36.711c0,.988-1.221,1.669-2.727,1.521Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.695,481.636l-.002-7.038c0-1.96,2.418-3.333,5.407-3.067l4.624,.412c3.005,.268,5.446,2.082,5.447,4.052l.004,7.075c.001,1.97-2.439,3.339-5.444,3.057l-4.624-.434c-2.99-.281-5.41-2.097-5.41-4.057Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.72,501.242h0c-1.528-.15-2.766-1.077-2.767-2.071l-.024-36.931c0-.993,1.236-1.693,2.763-1.564h0c1.529,.13,2.77,1.041,2.771,2.036l.027,37c0,.996-1.24,1.681-2.77,1.531Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.868,483.784l-.004-7.093c-.001-1.975,2.454-3.357,5.49-3.087l4.696,.418c3.052,.272,5.532,2.102,5.533,4.088l.006,7.131c.002,1.986-2.476,3.363-5.528,3.077l-4.697-.441c-3.037-.285-5.495-2.117-5.496-4.093Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.386,503.567h0c-1.552-.152-2.81-1.088-2.811-2.09l-.035-37.223c0-1.001,1.255-1.706,2.806-1.574h0c1.553,.132,2.814,1.051,2.815,2.054l.037,37.293c.001,1.004-1.259,1.693-2.813,1.541Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.405,485.965l-.006-7.149c-.002-1.991,2.492-3.382,5.576-3.107l4.771,.425c3.1,.276,5.62,2.123,5.622,4.124l.008,7.187c.002,2.002-2.514,3.388-5.615,3.097l-4.771-.448c-3.085-.289-5.582-2.138-5.584-4.129Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.428,505.929h0c-1.577-.155-2.855-1.099-2.856-2.109l-.046-37.52c-.001-1.009,1.274-1.719,2.851-1.585h0c1.578,.134,2.859,1.061,2.861,2.072l.048,37.59c.001,1.012-1.279,1.706-2.857,1.551Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.316,488.18l-.008-7.206c-.002-2.006,2.531-3.407,5.664-3.128l4.847,.432c3.15,.281,5.71,2.144,5.713,4.161l.01,7.245c.003,2.018-2.554,3.413-5.704,3.118l-4.848-.455c-3.134-.294-5.671-2.159-5.674-4.166Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.855,508.328h0c-1.602-.157-2.901-1.11-2.903-2.128l-.057-37.821c-.002-1.017,1.294-1.731,2.896-1.596h0c1.603,.136,2.905,1.072,2.907,2.091l.059,37.892c.002,1.02-1.299,1.719-2.903,1.561Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.608,490.431l-.011-7.264c-.003-2.023,2.571-3.433,5.754-3.149l4.925,.439c3.2,.285,5.803,2.165,5.806,4.199l.012,7.303c.003,2.034-2.594,3.439-5.795,3.138l-4.926-.462c-3.184-.299-5.763-2.181-5.766-4.204Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.677,510.766h0c-1.628-.16-2.949-1.121-2.951-2.147l-.068-38.127c-.002-1.025,1.315-1.745,2.942-1.607h0c1.629,.138,2.953,1.083,2.955,2.11l.071,38.2c.002,1.028-1.319,1.732-2.949,1.571Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.291,492.718l-.013-7.323c-.004-2.039,2.611-3.458,5.846-3.17l5.005,.446c3.252,.29,5.897,2.187,5.901,4.237l.014,7.362c.004,2.05-2.635,3.465-5.888,3.159l-5.005-.47c-3.236-.304-5.857-2.203-5.86-4.242Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.903,513.245h0c-1.655-.163-2.997-1.133-2.999-2.167l-.08-38.438c-.002-1.034,1.336-1.758,2.99-1.618h0c1.656,.14,3.001,1.094,3.004,2.129l.083,38.512c.002,1.036-1.34,1.745-2.997,1.582Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.376,495.043l-.015-7.382c-.004-2.055,2.653-3.485,5.94-3.192l5.086,.453c3.306,.294,5.994,2.209,5.999,4.276l.017,7.423c.005,2.067-2.677,3.491-5.983,3.181l-5.087-.477c-3.289-.309-5.953-2.225-5.957-4.281Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.49,556.977h0c-1.482-.176-2.683-1.113-2.683-2.093l-.004-36.413c0-.979,1.2-1.647,2.682-1.491h0c1.483,.156,2.687,1.078,2.687,2.058l.006,36.479c0,.982-1.204,1.635-2.688,1.459Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.881,539.621v-6.994c0-1.947,2.383-3.265,5.328-2.943l4.556,.499c2.961,.324,5.365,2.174,5.366,4.132l.002,7.03c0,1.958-2.404,3.27-5.365,2.932l-4.557-.52c-2.946-.337-5.33-2.188-5.33-4.136Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.446,559.7h0c-1.506-.179-2.725-1.124-2.726-2.111l-.014-36.696c0-.987,1.218-1.659,2.723-1.5h0c1.506,.158,2.729,1.088,2.729,2.077l.016,36.764c0,.989-1.222,1.646-2.729,1.468Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.714,542.202l-.002-7.048c0-1.962,2.419-3.288,5.411-2.961l4.627,.506c3.007,.329,5.45,2.196,5.451,4.169l.004,7.085c.001,1.973-2.44,3.294-5.448,2.95l-4.628-.529c-2.992-.342-5.413-2.21-5.414-4.173Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.762,562.466h0c-1.529-.181-2.768-1.135-2.769-2.131l-.024-36.984c0-.994,1.237-1.671,2.765-1.51h0c1.53,.161,2.772,1.099,2.773,2.095l.027,37.053c0,.997-1.241,1.658-2.772,1.477Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.904,544.824l-.004-7.104c-.001-1.978,2.456-3.312,5.494-2.979l4.7,.514c3.054,.334,5.536,2.218,5.537,4.206l.006,7.141c.002,1.989-2.478,3.318-5.532,2.969l-4.701-.537c-3.039-.347-5.499-2.232-5.5-4.21Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.445,565.276h0c-1.553-.184-2.812-1.147-2.813-2.15l-.035-37.277c0-1.002,1.256-1.683,2.808-1.52h0c1.554,.163,2.816,1.11,2.817,2.114l.037,37.347c.001,1.005-1.26,1.67-2.815,1.486Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.459,547.486l-.006-7.16c-.002-1.993,2.494-3.336,5.58-2.998l4.774,.523c3.102,.34,5.624,2.24,5.626,4.244l.008,7.198c.002,2.005-2.516,3.342-5.619,2.987l-4.775-.545c-3.087-.353-5.586-2.254-5.588-4.248Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.505,568.13h0c-1.578-.187-2.857-1.159-2.859-2.17l-.046-37.574c-.001-1.01,1.275-1.695,2.853-1.529h0c1.579,.166,2.861,1.121,2.863,2.133l.048,37.645c.001,1.013-1.28,1.682-2.859,1.495Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.387,550.191l-.008-7.217c-.002-2.009,2.533-3.36,5.668-3.017l4.85,.531c3.152,.345,5.714,2.263,5.717,4.283l.01,7.255c.003,2.021-2.555,3.366-5.708,3.006l-4.851-.554c-3.136-.358-5.676-2.278-5.678-4.287Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.951,571.03h0c-1.604-.19-2.904-1.171-2.905-2.19l-.057-37.876c-.002-1.018,1.295-1.708,2.898-1.539h0c1.604,.169,2.908,1.133,2.909,2.153l.059,37.948c.002,1.021-1.3,1.695-2.905,1.504Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.698,552.94l-.011-7.275c-.003-2.025,2.572-3.385,5.758-3.036l4.928,.539c3.203,.351,5.807,2.286,5.81,4.323l.012,7.314c.003,2.037-2.596,3.391-5.799,3.025l-4.929-.563c-3.187-.364-5.767-2.301-5.77-4.327Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.793,573.977h0c-1.63-.193-2.951-1.183-2.953-2.211l-.068-38.183c-.002-1.027,1.316-1.72,2.945-1.549h0c1.631,.171,2.955,1.144,2.957,2.173l.071,38.257c.002,1.03-1.32,1.707-2.952,1.514Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,555.732l-.013-7.333c-.004-2.042,2.613-3.41,5.851-3.056l5.008,.548c3.255,.356,5.902,2.31,5.906,4.363l.014,7.373c.004,2.053-2.637,3.416-5.892,3.044l-5.009-.572c-3.238-.37-5.861-2.325-5.865-4.367Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.039,576.972h0c-1.656-.196-2.999-1.196-3.002-2.232l-.08-38.495c-.002-1.035,1.337-1.733,2.992-1.559h0c1.657,.174,3.004,1.156,3.006,2.193l.083,38.57c.002,1.038-1.341,1.72-2.999,1.523Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.504,558.57l-.015-7.393c-.004-2.059,2.655-3.436,5.945-3.076l5.09,.557c3.308,.362,5.999,2.334,6.004,4.404l.017,7.434c.005,2.07-2.679,3.442-5.988,3.064l-5.091-.582c-3.291-.376-5.957-2.349-5.962-4.408Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.499,617.34h0c-1.483-.206-2.685-1.169-2.685-2.15l-.004-36.464c0-.98,1.201-1.625,2.684-1.439h0c1.484,.186,2.689,1.134,2.689,2.116l.006,36.531c0,.983-1.205,1.613-2.69,1.406Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.884,599.804v-7.004c0-1.95,2.384-3.221,5.332-2.838l4.559,.592c2.963,.385,5.369,2.286,5.37,4.247l.002,7.04c0,1.961-2.405,3.226-5.369,2.827l-4.56-.614c-2.948-.397-5.334-2.3-5.334-4.25Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.471,620.535h0c-1.507-.21-2.727-1.181-2.728-2.17l-.014-36.749c0-.988,1.219-1.636,2.725-1.447h0c1.507,.189,2.731,1.145,2.731,2.135l.016,36.816c0,.991-1.223,1.624-2.731,1.414Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.734,602.854l-.002-7.058c0-1.965,2.421-3.244,5.414-2.855l4.63,.601c3.009,.391,5.453,2.31,5.454,4.285l.004,7.095c.001,1.976-2.442,3.249-5.451,2.844l-4.631-.624c-2.994-.403-5.417-2.323-5.418-4.289Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.804,623.779h0c-1.53-.213-2.77-1.193-2.771-2.19l-.024-37.038c0-.996,1.238-1.648,2.767-1.456h0c1.531,.192,2.774,1.157,2.775,2.155l.027,37.106c0,.999-1.242,1.635-2.774,1.422Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,605.951l-.004-7.114c-.001-1.981,2.458-3.267,5.499-2.872l4.703,.611c3.056,.397,5.54,2.333,5.541,4.325l.006,7.151c.002,1.992-2.48,3.272-5.536,2.86l-4.704-.633c-3.041-.409-5.503-2.347-5.504-4.328Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.505,627.075h0c-1.555-.216-2.814-1.206-2.815-2.21l-.035-37.331c0-1.004,1.257-1.66,2.811-1.465h0c1.555,.195,2.818,1.169,2.819,2.175l.037,37.401c.001,1.007-1.261,1.647-2.817,1.431Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.512,609.097l-.006-7.17c-.002-1.996,2.496-3.29,5.585-2.889l4.778,.62c3.105,.403,5.628,2.358,5.63,4.365l.008,7.208c.002,2.007-2.518,3.295-5.623,2.877l-4.779-.643c-3.089-.416-5.59-2.371-5.592-4.368Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.583,630.423h0c-1.579-.22-2.86-1.218-2.861-2.231l-.046-37.629c-.001-1.012,1.276-1.672,2.855-1.473h0c1.58,.198,2.864,1.181,2.865,2.195l.048,37.7c.001,1.015-1.281,1.659-2.862,1.439Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.458,612.293l-.008-7.227c-.002-2.012,2.535-3.314,5.673-2.906l4.854,.63c3.154,.41,5.719,2.382,5.721,4.406l.01,7.266c.003,2.024-2.557,3.319-5.712,2.894l-4.855-.654c-3.139-.423-5.68-2.396-5.682-4.409Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.048,633.825h0c-1.605-.223-2.906-1.232-2.907-2.252l-.057-37.932c-.002-1.02,1.296-1.684,2.9-1.482h0c1.606,.202,2.91,1.193,2.912,2.215l.06,38.004c.002,1.023-1.301,1.671-2.907,1.447Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.788,615.54l-.011-7.285c-.003-2.028,2.574-3.338,5.763-2.924l4.932,.641c3.205,.416,5.811,2.408,5.815,4.447l.012,7.325c.003,2.04-2.598,3.343-5.803,2.911l-4.933-.664c-3.189-.429-5.772-2.422-5.775-4.451Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.908,637.282h0c-1.631-.227-2.953-1.245-2.955-2.274l-.068-38.24c-.002-1.028,1.317-1.696,2.947-1.491h0c1.632,.205,2.957,1.206,2.959,2.236l.071,38.313c.002,1.031-1.321,1.683-2.954,1.456Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.509,618.84l-.013-7.344c-.004-2.045,2.615-3.362,5.855-2.941l5.012,.651c3.257,.423,5.906,2.433,5.91,4.49l.014,7.384c.004,2.057-2.639,3.367-5.897,2.929l-5.013-.675c-3.241-.436-5.866-2.448-5.869-4.493Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.174,640.795h0c-1.658-.231-3.002-1.258-3.004-2.296l-.08-38.553c-.002-1.037,1.338-1.709,2.995-1.501h0c1.659,.208,3.006,1.219,3.008,2.258l.083,38.628c.002,1.04-1.342,1.695-3.002,1.464Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.633,622.193l-.015-7.404c-.004-2.062,2.657-3.387,5.95-2.959l5.094,.662c3.311,.43,6.004,2.46,6.008,4.533l.017,7.445c.005,2.073-2.681,3.392-5.992,2.946l-5.095-.686c-3.294-.443-5.962-2.474-5.966-4.536Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.507,677.789h0c-1.485-.237-2.687-1.225-2.687-2.208l-.004-36.516c0-.982,1.202-1.602,2.685-1.386h0c1.485,.217,2.691,1.19,2.691,2.174l.006,36.583c0,.985-1.205,1.59-2.691,1.353Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.888,660.073v-7.014c0-1.953,2.386-3.177,5.336-2.734l4.562,.686c2.965,.446,5.373,2.399,5.373,4.362l.002,7.05c0,1.963-2.407,3.182-5.372,2.722l-4.563-.708c-2.95-.458-5.338-2.411-5.338-4.365Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.496,681.456h0c-1.508-.24-2.729-1.238-2.73-2.229l-.014-36.801c0-.99,1.22-1.614,2.727-1.394h0c1.509,.22,2.733,1.202,2.733,2.194l.016,36.869c0,.992-1.224,1.601-2.733,1.361Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.753,663.592l-.002-7.068c0-1.968,2.423-3.199,5.418-2.749l4.634,.697c3.011,.453,5.457,2.424,5.458,4.403l.004,7.106c.001,1.979-2.444,3.204-5.455,2.737l-4.635-.719c-2.996-.465-5.421-2.437-5.422-4.405Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.846,685.18h0c-1.531-.244-2.772-1.251-2.773-2.25l-.024-37.091c0-.997,1.239-1.625,2.769-1.402h0c1.532,.224,2.776,1.215,2.777,2.214l.027,37.16c0,1-1.243,1.612-2.776,1.368Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.977,667.166l-.004-7.124c-.001-1.984,2.46-3.221,5.503-2.764l4.707,.707c3.059,.46,5.544,2.45,5.545,4.444l.006,7.162c.002,1.994-2.481,3.226-5.54,2.752l-4.707-.73c-3.043-.472-5.507-2.462-5.508-4.446Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.564,688.963h0c-1.556-.248-2.817-1.265-2.817-2.271l-.035-37.385c0-1.005,1.258-1.636,2.813-1.409h0c1.557,.227,2.82,1.228,2.821,2.235l.037,37.455c.001,1.008-1.262,1.624-2.819,1.375Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.566,670.797l-.006-7.18c-.002-1.999,2.498-3.244,5.589-2.779l4.781,.719c3.107,.467,5.632,2.476,5.635,4.486l.008,7.219c.002,2.01-2.52,3.249-5.628,2.767l-4.782-.742c-3.092-.479-5.595-2.489-5.596-4.488Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.661,692.807h0c-1.581-.252-2.862-1.279-2.863-2.293l-.046-37.684c-.001-1.013,1.277-1.648,2.857-1.417h0c1.581,.231,2.866,1.241,2.867,2.256l.048,37.756c.001,1.016-1.282,1.635-2.864,1.383Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.53,674.486l-.008-7.238c-.002-2.015,2.537-3.267,5.677-2.795l4.858,.73c3.157,.475,5.723,2.502,5.726,4.529l.01,7.277c.003,2.027-2.559,3.272-5.717,2.782l-4.859-.754c-3.141-.487-5.684-2.515-5.687-4.531Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.144,696.712h0c-1.606-.256-2.908-1.293-2.91-2.315l-.057-37.988c-.002-1.021,1.297-1.66,2.903-1.425h0c1.607,.235,2.912,1.254,2.914,2.278l.06,38.061c.002,1.024-1.302,1.647-2.909,1.39Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.878,678.233l-.011-7.296c-.003-2.031,2.576-3.29,5.767-2.81l4.936,.742c3.208,.482,5.816,2.53,5.819,4.572l.012,7.336c.003,2.043-2.6,3.295-5.808,2.797l-4.937-.766c-3.191-.495-5.776-2.543-5.779-4.575Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.024,700.681h0c-1.632-.26-2.956-1.307-2.957-2.337l-.069-38.297c-.002-1.03,1.318-1.672,2.949-1.434h0c1.633,.238,2.96,1.268,2.962,2.3l.071,38.371c.002,1.033-1.322,1.658-2.956,1.398Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.618,682.041l-.013-7.355c-.004-2.048,2.617-3.314,5.86-2.826l5.016,.754c3.26,.49,5.911,2.557,5.915,4.617l.014,7.395c.004,2.06-2.641,3.319-5.901,2.813l-5.017-.778c-3.243-.503-5.87-2.571-5.874-4.619Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.31,704.714h0c-1.659-.265-3.004-1.321-3.006-2.36l-.081-38.611c-.002-1.038,1.339-1.684,2.997-1.442h0c1.66,.242,3.008,1.282,3.011,2.322l.083,38.686c.002,1.041-1.343,1.67-3.004,1.405Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.762,685.911l-.015-7.415c-.004-2.065,2.659-3.338,5.954-2.842l5.098,.766c3.313,.498,6.009,2.586,6.013,4.662l.017,7.456c.005,2.077-2.683,3.342-5.997,2.828l-5.099-.791c-3.296-.511-5.967-2.599-5.971-4.664Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.516,738.323h0c-1.486-.267-2.689-1.282-2.689-2.266l-.004-36.568c0-.983,1.202-1.58,2.687-1.333h0c1.486,.247,2.693,1.247,2.693,2.232l.006,36.635c0,.986-1.206,1.568-2.693,1.3Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.891,720.427v-7.024c0-1.956,2.388-3.133,5.34-2.629l4.566,.78c2.967,.507,5.377,2.512,5.377,4.478l.002,7.06c0,1.966-2.409,3.137-5.376,2.616l-4.567-.802c-2.952-.518-5.341-2.524-5.342-4.48Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.521,742.464h0c-1.509-.272-2.731-1.296-2.732-2.287l-.014-36.854c0-.991,1.221-1.591,2.729-1.34h0c1.51,.251,2.735,1.26,2.735,2.253l.016,36.922c0,.994-1.225,1.579-2.735,1.307Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.773,724.417l-.002-7.079c0-1.971,2.425-3.154,5.422-2.642l4.637,.792c3.013,.515,5.461,2.539,5.462,4.52l.004,7.116c.001,1.982-2.446,3.158-5.459,2.629l-4.638-.814c-2.998-.526-5.425-2.551-5.426-4.522Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.888,746.67h0c-1.533-.276-2.774-1.31-2.775-2.309l-.024-37.144c0-.999,1.239-1.602,2.771-1.347h0c1.533,.255,2.778,1.273,2.779,2.274l.027,37.214c0,1.002-1.244,1.589-2.778,1.313Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.013,728.47l-.004-7.134c-.001-1.986,2.462-3.176,5.507-2.656l4.71,.804c3.061,.523,5.548,2.566,5.55,4.563l.006,7.172c.002,1.997-2.483,3.18-5.545,2.643l-4.711-.827c-3.046-.535-5.511-2.578-5.512-4.565Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.624,750.942h0c-1.557-.28-2.819-1.324-2.82-2.332l-.035-37.44c0-1.007,1.259-1.613,2.815-1.354h0c1.558,.259,2.823,1.287,2.824,2.296l.037,37.51c.001,1.01-1.263,1.6-2.821,1.32Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.62,732.587l-.006-7.191c-.002-2.002,2.5-3.198,5.593-2.669l4.785,.817c3.109,.531,5.637,2.594,5.639,4.607l.008,7.229c.002,2.013-2.522,3.202-5.632,2.656l-4.786-.84c-3.094-.543-5.599-2.606-5.6-4.609Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.739,755.283h0c-1.582-.285-2.864-1.339-2.865-2.354l-.046-37.74c-.001-1.015,1.278-1.624,2.859-1.361h0c1.583,.263,2.868,1.301,2.869,2.318l.048,37.811c.001,1.018-1.282,1.611-2.866,1.326Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.602,736.769l-.008-7.248c-.002-2.018,2.539-3.22,5.681-2.683l4.861,.83c3.159,.54,5.727,2.623,5.73,4.652l.01,7.287c.003,2.029-2.561,3.224-5.721,2.669l-4.862-.854c-3.143-.552-5.689-2.635-5.691-4.654Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.241,759.693h0c-1.607-.289-2.91-1.354-2.912-2.378l-.057-38.044c-.002-1.023,1.298-1.636,2.905-1.368h0c1.608,.268,2.914,1.316,2.916,2.34l.06,38.117c.002,1.026-1.303,1.622-2.912,1.333Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.968,741.018l-.011-7.307c-.003-2.034,2.578-3.242,5.772-2.697l4.94,.844c3.21,.548,5.82,2.652,5.824,4.697l.012,7.346c.003,2.046-2.602,3.247-5.812,2.683l-4.941-.867c-3.194-.561-5.781-2.664-5.784-4.699Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.14,764.175h0c-1.633-.294-2.958-1.369-2.96-2.401l-.069-38.354c-.002-1.031,1.319-1.647,2.952-1.376h0c1.634,.272,2.962,1.33,2.964,2.364l.071,38.428c.002,1.034-1.323,1.634-2.959,1.339Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.728,745.336l-.013-7.366c-.004-2.051,2.619-3.265,5.864-2.711l5.02,.857c3.263,.557,5.916,2.682,5.92,4.744l.014,7.406c.004,2.063-2.643,3.27-5.906,2.697l-5.021-.882c-3.246-.57-5.875-2.694-5.879-4.746Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.445,768.729h0c-1.66-.299-3.007-1.385-3.009-2.425l-.081-38.669c-.002-1.04,1.34-1.659,2.999-1.383h0c1.661,.276,3.011,1.345,3.013,2.387l.084,38.744c.002,1.043-1.345,1.645-3.007,1.346Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.891,749.724l-.015-7.427c-.004-2.068,2.661-3.288,5.959-2.725l5.102,.871c3.316,.566,6.013,2.712,6.018,4.791l.017,7.467c.005,2.08-2.685,3.293-6.002,2.71l-5.103-.896c-3.299-.579-5.972-2.725-5.976-4.793Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.524,798.943h0c-1.487-.298-2.691-1.338-2.691-2.324l-.004-36.62c0-.985,1.203-1.558,2.689-1.28h0c1.487,.278,2.695,1.303,2.695,2.29l.006,36.687c0,.987-1.207,1.546-2.695,1.247Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.894,780.866v-7.034c0-1.958,2.39-3.089,5.343-2.524l4.569,.874c2.969,.568,5.381,2.625,5.381,4.594l.002,7.07c0,1.969-2.411,3.092-5.38,2.51l-4.57-.896c-2.954-.579-5.345-2.636-5.345-4.595Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.547,803.559h0c-1.51-.303-2.733-1.353-2.733-2.346l-.014-36.907c0-.992,1.222-1.568,2.731-1.286h0c1.511,.282,2.737,1.317,2.737,2.312l.016,36.975c0,.995-1.226,1.556-2.737,1.253Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.792,785.329l-.002-7.089c0-1.974,2.426-3.109,5.426-2.535l4.64,.888c3.015,.577,5.465,2.654,5.466,4.638l.004,7.126c.001,1.985-2.447,3.113-5.463,2.522l-4.641-.91c-3.001-.588-5.429-2.665-5.43-4.639Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.93,808.248h0c-1.534-.308-2.776-1.368-2.777-2.369l-.024-37.198c0-1,1.24-1.579,2.773-1.292h0c1.535,.287,2.78,1.332,2.781,2.334l.027,37.267c0,1.003-1.244,1.566-2.78,1.258Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.05,789.862l-.004-7.145c-.001-1.989,2.463-3.13,5.511-2.547l4.714,.902c3.063,.586,5.552,2.683,5.554,4.683l.006,7.182c.002,2-2.485,3.134-5.549,2.533l-4.714-.924c-3.048-.598-5.515-2.694-5.516-4.684Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.684,813.011h0c-1.558-.312-2.821-1.383-2.822-2.393l-.035-37.494c0-1.008,1.26-1.59,2.817-1.299h0c1.559,.291,2.825,1.347,2.826,2.357l.037,37.565c.001,1.011-1.264,1.577-2.823,1.264Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.674,794.466l-.006-7.201c-.002-2.005,2.502-3.151,5.597-2.559l4.788,.916c3.112,.595,5.641,2.713,5.643,4.729l.008,7.24c.002,2.016-2.524,3.155-5.636,2.545l-4.789-.939c-3.096-.607-5.603-2.724-5.605-4.73Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.817,817.85h0c-1.583-.317-2.866-1.399-2.867-2.416l-.046-37.795c-.001-1.016,1.279-1.601,2.861-1.305h0c1.584,.296,2.87,1.362,2.871,2.38l.048,37.866c.001,1.019-1.283,1.587-2.868,1.27Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674,799.143l-.008-7.259c-.002-2.021,2.54-3.173,5.685-2.571l4.865,.931c3.162,.605,5.732,2.743,5.735,4.775l.01,7.298c.003,2.032-2.563,3.177-5.725,2.557l-4.866-.954c-3.146-.617-5.693-2.755-5.695-4.776Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.337,822.766h0c-1.609-.323-2.913-1.415-2.914-2.44l-.057-38.1c-.002-1.024,1.299-1.612,2.907-1.311h0c1.609,.301,2.917,1.377,2.918,2.403l.06,38.173c.002,1.027-1.304,1.598-2.914,1.275Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.058,803.896l-.011-7.318c-.003-2.037,2.58-3.194,5.776-2.583l4.944,.946c3.213,.615,5.825,2.774,5.828,4.823l.012,7.357c.003,2.049-2.604,3.198-5.817,2.568l-4.945-.97c-3.196-.627-5.785-2.786-5.788-4.824Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.256,827.763h0c-1.635-.328-2.96-1.431-2.962-2.465l-.069-38.411c-.002-1.033,1.32-1.623,2.954-1.317h0c1.636,.306,2.964,1.393,2.966,2.427l.072,38.485c.002,1.036-1.324,1.609-2.961,1.281Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.837,808.725l-.013-7.377c-.004-2.054,2.621-3.216,5.869-2.595l5.024,.961c3.265,.625,5.92,2.806,5.924,4.871l.014,7.418c.004,2.066-2.645,3.22-5.911,2.58l-5.025-.985c-3.248-.637-5.88-2.818-5.883-4.872Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.581,832.841h0c-1.662-.333-3.009-1.448-3.011-2.49l-.081-38.727c-.002-1.041,1.341-1.634,3.002-1.324h0c1.662,.311,3.013,1.409,3.016,2.452l.084,38.802c.002,1.044-1.346,1.62-3.009,1.287Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.02,813.633l-.015-7.438c-.004-2.071,2.663-3.239,5.964-2.607l5.107,.977c3.319,.635,6.018,2.839,6.023,4.921l.017,7.479c.005,2.083-2.688,3.243-6.007,2.592l-5.107-1.001c-3.302-.647-5.976-2.85-5.981-4.922Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.815,
    y: 575.37,
    width: 172.46,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.052,
    y: 590.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.051,
    y: 590.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(952.671 265.48) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.537,
    y: 590.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.536,
    y: 590.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1008.155 209.995) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 590.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 590.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1063.639 154.509) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.052,
    y: 646.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.051,
    y: 646.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1008.68 321.487) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.537,
    y: 646.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.536,
    y: 646.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1064.164 266.002) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 646.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 646.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1119.648 210.517) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.052,
    y: 702.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.051,
    y: 702.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1064.689 377.495) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.537,
    y: 702.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.536,
    y: 702.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1120.173 322.009) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 702.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 702.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1175.657 266.524) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.052,
    y: 758.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.051,
    y: 758.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1120.697 433.502) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.537,
    y: 758.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.536,
    y: 758.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1176.181 378.017) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 758.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 758.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1231.665 322.531) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.052,
    y: 814.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.051,
    y: 814.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1176.706 489.509) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.537,
    y: 814.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.536,
    y: 814.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1232.19 434.024) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 814.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 814.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1287.674 378.539) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.052,
    y: 870.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.051,
    y: 870.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1232.715 545.517) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.537,
    y: 870.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.536,
    y: 870.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1288.199 490.031) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 870.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.022,
    y: 870.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1343.683 434.546) rotate(89.999)",
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.836,606.897v4.99c0,1.04-.16,2.05-.46,2.99-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01-.3-.94-.46-1.95-.46-2.99v-4.99h127.515Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.316,
    y: 600.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.432,
    y: 600.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.376,614.877c-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01h126.595Z",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.36,304.06c-1.42-.16-2.86-.22-4.22-.23-26.55-.12-53.1-.02-79.64,.3-6.32,.08-12.64,.17-18.96,.26-15.41,.22-30.82,.43-46.23,.65-.9,.02-1.8,.03-2.7,.04-7.22,.12-14.45,.28-21.65,.8-7.16,.5-14.31,1.35-21.33,2.84-1.96,.42-3.91,.88-5.84,1.41V4.53l11.95-.27c1.46,.43,2.94,.86,4.42,1.24,22.48,5.77,46.16,.7,69.27,2.07,8.07,.48,16.08,1.76,24.15,2.31,8.17,.54,16.38,.35,24.57,.15,10.68-.26,21.4-.52,31.93-2.69,6.72-1.38,13.52-3.55,20.26-2.57,2.56,.36,5.08,1.18,7.68,1.21,2.03,.02,4.18-.56,5.75-1.97l.59,300.05Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(323.91 225.822)",
    fontFamily: "Lato-Black, Lato",
    fontSize: 31
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".079em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.49,
    y: 0,
    letterSpacing: ".116em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.128,
    y: 0,
    letterSpacing: ".14em"
  }, "CUUM"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42,
    letterSpacing: ".134em"
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.7,
    y: 42,
    letterSpacing: ".14em"
  }, "ORMER")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuumFormer);
export default __webpack_public_path__ + "static/media/vacuum-former.016b117043d0a0f852f8746c4eefcb65.svg";
export { ForwardRef as ReactComponent };